const EXTERNAL_LINKS = {
	tickets: "https://www.entrio.hr/event/weblica-2025-20699",
	sessions: "https://sessionize.com/weblica-2025/",
}

const TRACK_BREAK = (duration) => {
	return {
		duration: duration || 10,
		break: true,
		doNotEvaluate: true,
		title: {
			hr: "Pauza za kavu",
			en: "Coffee Break",
		},
		poweredBy: {
			name: "cWebSpace"
		}
	}
}

const LUNCH_BREAK = (duration) => {
	return {
		duration: duration || 60,
		break: true,
		lunch: true,
		title: {
			hr: "Ručak",
			en: "Midday Break & Lunch",
		},
		// poweredBy: {
		// 	name: "Full Circle"
		// },
		description: {
			hr: "",
			en: [
				"<p>Take a breather. Grab some lunch from Full Circle, say hi to someone new or visit the partner booths.</p>",
				"<p>No rush - lunch will be available until 15:00.</p>"
			]
		},
	}
}

module.exports = {
	currentYear: 2025,
	dateLimits: {
		// TODO (LOW) - introduce local event-specific version along this generic one (event-specific can override generic)
		ticketSales: {
			weblica: {
				from: null,
				to: "2025-05-08 23:59:59", // this needs to match last ticket sale date
			},
			worklica: {
				from: null,
				to: "2025-05-08 23:59:59", // this needs to match last ticket sale date
			},
		},
		lectureRegistration: {
			from: null,
			to: "2025-02-28 23:59:59",
		},
		workshopRegistration: {
			from: null,
			to: "2025-02-28 23:59:59",
		},
		teamRegistration: {
			from: null,
			to: "2025-04-30 23:59:59",
		},
		sponsorRegistration: {
			from: null,
			to: "2025-04-30 23:59:59",
		},
		exhibitorRegistration: {
			from: null,
			to: null, // "2025-04-30 23:59:59",
		},
		pressRegistration: {
			from: null,
			to: "2025-04-30 23:59:59",
		},
		volunteerRegistration: {
			from: null,
			to: "2025-04-25 11:00:00",
		},
		lastYearSurveyButton: {
			from: null,
			to: "2024-12-31 23:59:59",
		},
		registerToWorkshops: {
			from: null,
			to: "2025-05-09 23:59:59"
		}
	},
	assets: {
		sponsorBrochure: {
			ident: {
				hr: "",
				en: "",
			},
			enabled: false,
		},
		exhibitorBrochure: {
			ident: {
				hr: "",
				en: "",
			},
			enabled: false,
		},
	},
	footerLinks: {
		code: {
			visible: true,
			extra: false,
			url: "/code",
			text: "more.code",
		},
		terms: {
			visible: true,
			extra: false,
			url: "/terms",
			text: "more.terms",
		},
		privacy: {
			visible: true,
			extra: false,
			url: "/privacy",
			text: "more.privacy",
		},
		recording: {
			visible: true,
			extra: false,
			url: "/recording",
			text: "more.recording",
		},
		safety: {
			visible: false,
			extra: true,
			url: "/safety",
			text: "more.safety",
		},
		press: {
			visible: true,
			extra: true,
			url: "/press",
			text: "more.press",
		},
		sponsor: {
			visible: true,
			extra: false,
			url: "/sponsors",
			text: "more.sponsor",
			dateLimit: "sponsorRegistration",
		},
		exhibitor: {
			visible: false,
			extra: false,
			url: "/exhibitors",
			text: "more.exhibitor",
			dateLimit: "exhibitorRegistration",
		},
		volunteer: {
			visible: true,
			extra: false,
			url: "/volunteer",
			text: "more.volunteer",
			dateLimit: "volunteerRegistration",
		},
	},
	events: {
		weblica: {
			__days: [
				// DEV-ONLY
				{
					startDateTime: "2025-01-15 08:00:00",
					endDateTime: "2025-01-15 23:59:59",
				},
				{
					startDateTime: "2025-03-18 08:00:00",
					endDateTime: "2025-03-18 23:59:59",
				},
				{
					startDateTime: "2025-05-09 08:00:00",
					endDateTime: "2025-05-09 23:59:59",
				},
				{
					startDateTime: "2025-06-13 08:00:00",
					endDateTime: "2025-06-13 23:59:59",
					speakers: {
						"test-speaker": {
							visible: true,
							placeholder: false,
							// image: "blau-frank.jpg",
							name: "Test",
							surname: "Speaker",
							contact: {
								email: "xxx@gmail.com",
							},
							position: {
								hr: "Somebody at Somewhere",
								en: "Somebody at Somewhere",
							},
							bio: {
								hr: "Biography of a Test Speaker - he is cool, he knows things. He is a template.",
								en: "Biography of a Test Speaker - he is cool, he knows things. He is a template.",
							},
							social: {
								linkedIn: "https://www.linkedin.com/in/xxx",
							},
						},
					},
					sessions: [
						{
							visible: true,
							placeholder: false,
							ident: "test-session",
							duration: 45,
							type: "talk",
							language: "en",
							level: "intermediate",
							code: "light",
							title: {
								hr: "Test Session",
								en: "Test Session",
							},
							description: {
								hr: "This is a description for test session.",
								en: "This is a description for test session.",
							},
							speakers: ["test-speaker"],
						},
					],
					schedule: [],
					venue: {
						venue: "vxy"
					},
					tickets: [
						{
							ident: "dev-spec",
							icon: "standard",
							title: {
								hr: "DevSpec",
								en: "DevSpec",
							},
							// description: {
							// 	hr: "",
							// 	en: [
							// 		"<p>This ticket gives you access to all conference sessions, three meals, after party, and the entry to <a href='https://vidikovac.eu/?lang=en' target='_blank'>Lookout Mađerkin Breg</a> Štrigova (with valid Weblica ticket).</p>",
							// 	]
							// },
							price: 20,
							listed: true,
							available: true,
							startDate: "2025-01-01",
							endDate: "2025-05-09 23:59:59",
							// access: {
							// 	conference: true,
							// 	snacks: true,
							// 	three_meals: true,
							// 	after: true,
							// 	extra_madjerka: true,
							// 	workshops: true,
							// },
						},
					]
				},
				{
					startDateTime: "2025-09-19 08:00:00",
					endDateTime: "2025-09-19 23:59:59",
				},
			],
			// previewMode: ["schedule"],
			// workInProgress: ["speakers", "schedule"],
			tracks: ["track1"],
			externalLinks: EXTERNAL_LINKS,
			startDateTime: "2025-05-09 08:00:00",
			endDateTime: "2025-05-09 23:59:59",
			options: {
				entrioEventID: "20699",
			},
			topicsTags: {
				hr: [
					"<b>JavaScript</b>",
					"NodeJS",
					"Bun",
					"React",
					"Vue",
					"Ember",
					"Angular",
					"Svelte",
					"NextJS",
					"Gatsby",
					"NuxtJS",
					"...",
					"<b>PHP</b>",
					"Laravel",
					"Symphony",
					"CakePHP",
					"CodeIgniter",
					"Zend Framework",
					"...",
					"<b>.NET</b>",
					"Azure Cloud Development",
					"Xamarin",
					"Blazor",
					"ML.NET",
					"<b>Python</b>",
					"Flask",
					"Django",
					"CherryPy",
					"Bottle",
					"...",
					"Web",
					"APIs",
					"Services",
					"PWAs",
					"...",
					"<b>Security</b>",
					"OWASP",
					"PenTesting",
					"...",
					"UI",
					"UX",
					"...",
					"Git",
					"Docker",
					"DevOps",
					"Cloud",
					"...",
					"AI",
					"ChatBots",
					"LowCode/NoCode",
					"Blockchain",
					"...",
				],
				en: [
					"<b>JavaScript</b>",
					"NodeJS",
					"Bun",
					"React",
					"Vue",
					"Ember",
					"Angular",
					"Svelte",
					"NextJS",
					"Gatsby",
					"NuxtJS",
					"...",
					"<b>PHP</b>",
					"Laravel",
					"Symphony",
					"CakePHP",
					"CodeIgniter",
					"Zend Framework",
					"...",
					"<b>.NET</b>",
					"Azure Cloud Development",
					"Xamarin",
					"Blazor",
					"ML.NET",
					"<b>Python</b>",
					"Flask",
					"Django",
					"CherryPy",
					"Bottle",
					"...",
					"Web",
					"APIs",
					"Services",
					"PWAs",
					"...",
					"<b>Security</b>",
					"OWASP",
					"PenTesting",
					"...",
					"UI",
					"UX",
					"...",
					"Git",
					"Docker",
					"DevOps",
					"Cloud",
					"...",
					"AI",
					"ChatBots",
					"LowCode/NoCode",
					"Blockchain",
					"...",
				],
			},
			menuItems: {
				about: {
					url: "/weblica#about",
					visible: false,
				},
				news: {
					url: "/weblica#news",
					visible: false,
				},
				speakers: {
					url: "/weblica#speakers",
					visible: true,
				},
				schedule: {
					url: "/weblica#schedule",
					visible: true,
				},
				venue: {
					url: "/weblica#venue",
					visible: "active,before", // true || false || "active,before,after" (status dependant)
				},
				faq: {
					url: "/weblica#faq",
					visible: "active,before",
				},
				sponsors: {
					url: "/weblica#sponsors",
					visible: true,
				},
				tickets: {
					url: "/weblica#tickets",
					visible: false,
				},
				testimonials: {
					url: "/weblica#testimonials",
					visible: false,
				},
			},
			buttons: {
				lecture: {
					title: "Call for Speakers",
					url: EXTERNAL_LINKS.sessions,
					hollow: true,
					external: true,
					visible: false,
					visibleOnHero: true,
					wide: true,
					// full: true,
					dateLimit: "lectureRegistration",
				},
				tickets: {
					title: "Get Tickets",
					url: "/weblica#tickets",
					hollow: false,
					external: false,
					visible: true,
					dateLimit: "ticketSales.weblica",
					//---
					visibleOnHero: true,
					hollowOnHero: true,
					extraClassesOnHero: ["showOnSmall"],
					//---
					floatingSpecial: {
						// if defined, it will override given when on floating menu - this jumps directly to Entrio instead of to #tickets section
						url: EXTERNAL_LINKS.tickets,
						external: true,
					},
				},
			},
			forcedButtons: {
				sponsor: {
					title: "Become a Sponsor",
					url: "/sponsors",
					hollow: true,
					external: false,
					visible: true,
					linkInFooter: true,
					dateLimit: "sponsorRegistration",
				},
				exhibitor: {
					title: "Become an Exhibitor",
					url: "/exhibitors",
					hollow: true,
					external: false,
					visible: false,
					linkInFooter: false,
					dateLimit: "exhibitorRegistration",
				},
				volunteer: {
					title: "Become a Volunteer",
					url: "/volunteer",
					hollow: true,
					external: false,
					visible: false,
					linkInFooter: true,
					dateLimit: "volunteerRegistration",
				},
			},
			sections: {
				hero: {
					visible: true,
					blocks: [],
					// introImage: {
					// 	file: "WEBLICA_banner_1280x720.png",
					// 	// file: "weblica-2024-125-1.jpg",
					// 	// file: "weblica-8105.jpg",
					// 	// file: "weblica-7988.jpg",
					// 	alt: "Weblica Graphics",
					// },
					introVideo: [
						{
							media: "(max-width: 640px)",
							url: "/media/WEBLICA_banner_animation_640x360.mp4",
							poster: "/media/WEBLICA_banner_1280x720.png",
							type: "video/mp4",
						},
						{
							media: "(max-width: 1280px)",
							url: "/media/WEBLICA_banner_animation_1280x720.mp4",
							poster: "/media/WEBLICA_banner_1280x720.png",
							type: "video/mp4",
						},
						{
							media: "(min-width: 1281px)",
							url: "/media/WEBLICA_banner_animation_1920x1080.mp4",
							poster: "/media/WEBLICA_banner_1920x1080.png",
							type: "video/mp4",
						},
					],
				},
				about: {
					visible: true,
					blocks: [
						{
							width: "half", // full || half
							image: {
								file: "weblica-7573.jpg",
								alt: "Weblica 2019",
							},
						},
						{
							width: "half",
							text: "txt_aaa",
						},
						{
							width: "half",
							text: "txt_bbb",
						},
						{
							width: "half",
							image: {
								// file: "weblica-7810.jpg",
								file: "weblica-2024-24.jpg",
								alt: "Weblica 2024",
							},
						},
						{
							width: "half",
							// image: {
							// 	file: "weblica-8036.jpg",
							// 	alt: "Weblica 2019",
							// },
							gallery: [
								{
									// title: "weblica-2024-181.jpg",
									img: "weblica-2024-181.jpg",
									alt: "Weblica 2024",
								},
								{
									// title: "weblica-2024-102.jpg",
									img: "weblica-2024-102.jpg",
									alt: "Weblica 2024",
								},
								{
									// title: "weblica-2024-125.jpg",
									img: "weblica-2024-125.jpg",
									alt: "Weblica 2024",
								},
								{
									// title: "weblica-2024-303.jpg",
									img: "weblica-2024-303.jpg",
									alt: "Weblica 2024",
								},
							],
						},
						{
							width: "half",
							text: "txt_ccc",
						},
					],
				},
				news: {
					visible: false,
				},
				speakers: {
					visible: true,
				},
				schedule: {
					visible: true,
				},
				venue: {
					visible: "before,active",
				},
				tickets: {
					visible: "before,active",
				},
				faq: {
					visible: "before,active",
				},
				testimonials: {
					visible: true,
				},
				historyGallery: {
					visible: true,
				},
				sponsors: {
					visible: true,
				},
				newsletter: {
					visible: true,
				},
			},
			venue: {
				venue: "dks",
			},
			_DEV_venue: [
				{
					ident: "dks",
					name: {
						hr: "Dom Kulture Štrigova",
						en: "Dom Kulture Štrigova",
					},
					nameAlt: {
						hr: "Dom Kulture Štrigova",
						en: "Dom Kulture Štrigova",
					},
					street: "Štrigova 103",
					postalCode: "40312",
					city: "Štrigova",
					country: "Croatia",
					countryShort: "HR",
					mapImage: "strigova-dom-kulture-map-2.jpg",
					mapUrl:
						"https://www.google.hr/maps/place/%C5%A0trigova+103,+40312,+%C5%A0trigova/@46.5001192,16.2885758,17z/data=!4m6!3m5!1s0x476f4ec49751d3a1:0x84a12a23fd1ca131!8m2!3d46.5001377!4d16.2901422!16s%2Fg%2F11rqx_d1s4?hl=hr&entry=ttu&g_ep=EgoyMDI0MTAwOC4wIKXMDSoASAFQAw%3D%3D",
					images: [
						{
							// title: "Zgrada Doma kulture",
							img: "dom_kulture_strigova-10.jpg",
						},
						{
							// title: "Glavna dvorana",
							img: "dom_kulture_strigova-8.jpg",
						},
						{
							// title: "Zona za partnere i pauze",
							img: "dom_kulture_strigova-2.jpg",
						},
						{
							// title: "Zona za partnere i pauze",
							img: "dom_kulture_strigova-a1.jpg",
						},
						{
							// title: "Chill out zona",
							img: "dom_kulture_strigova-3.jpg",
						},
					],
				},
				{
					ident: "dks2",
					name: {
						hr: "Dom Kulture Štrigova 2",
						en: "Dom Kulture Štrigova 2",
					},
					nameAlt: {
						hr: "Dom Kulture Štrigova",
						en: "Dom Kulture Štrigova",
					},
					street: "Štrigova 103",
					postalCode: "40312",
					city: "Štrigova",
					country: "Croatia",
					countryShort: "HR",
					mapImage: "strigova-dom-kulture-map-2.jpg",
					mapUrl:
						"https://www.google.hr/maps/place/%C5%A0trigova+103,+40312,+%C5%A0trigova/@46.5001192,16.2885758,17z/data=!4m6!3m5!1s0x476f4ec49751d3a1:0x84a12a23fd1ca131!8m2!3d46.5001377!4d16.2901422!16s%2Fg%2F11rqx_d1s4?hl=hr&entry=ttu&g_ep=EgoyMDI0MTAwOC4wIKXMDSoASAFQAw%3D%3D",
					// images: [
					// 	{
					// 		// title: "Zgrada Doma kulture",
					// 		img: "dom_kulture_strigova-10.jpg"
					// 	},
					// 	{
					// 		// title: "Glavna dvorana",
					// 		img: "dom_kulture_strigova-8.jpg"
					// 	},
					// 	{
					// 		// title: "Zona za partnere i pauze",
					// 		img: "dom_kulture_strigova-2.jpg"
					// 	},
					// 	{
					// 		// title: "Zona za partnere i pauze",
					// 		img: "dom_kulture_strigova-a1.jpg"
					// 	},
					// 	{
					// 		// title: "Chill out zona",
					// 		img: "dom_kulture_strigova-3.jpg"
					// 	},
					// ],
				},
			],
			speakers: {
				"begedin-nikola": {
					visible: true,
					placeholder: false,
					image: "begedin-nikola.jpg",
					name: "Nikola",
					surname: "Begedin",
					contact: {
						email: "begedinnikola@gmail.com",
						phone: "091 890 9997",
					},
					position: {
						hr: "",
						en: "Freelancer, Tech Lead @ V7",
					},
					bio: {
						hr: "",
						en: "Started with .NET, added some JS to the mix, to become full stack, then shifted to Ruby on Rails with Ember, soon replaced by Elixir on backend and basically anything on the frontend (currently Vue).",
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/nikola-begedin-54541036/",
					},
				},
				"blau-frank": {
					visible: true,
					placeholder: false,
					image: "blau-frank.jpg",
					name: "Frank",
					surname: "Blau",
					contact: {
						email: "fjblau@gmail.com",
					},
					position: {
						hr: "Data Architect @ Innerspace",
						en: "Data Architect @ Innerspace",
					},
					bio: {
						hr: "Frank Blau has been a Business Intelligence Data Architect for 20 years and has over 25 years of technical experience in relational and dimensional database technologies.  He is currently a Data Architect at Innerspace in Innsbruck, Austria. He has been a developer, architect, analyst and educator in a variety of vertical markets and technologies.  Frank has also been a consultant to Fortune 500 and mid-market companies in the use and implementation of data warehouse architectures, unstructured data, metadata management and analytic presentation.\r\n\r\nFrank is a 2018 and 2020 IBM Champion for Cloud and Blockchain, and was a 2014 IBM Champion for Information Management. He continues to provide thought leadership and research in such diverse areas as Streaming Data, Blockchain, Modern Data Architecture and Cloud Computing. Frank is also a public speaker and author on topics related to Business Intelligence, disruptive technologies, mobile computing and software methodologies and is also a member of the Digitale Initiativen in Dornbirn, Austria. \r\n",
						en: "Frank Blau has been a Business Intelligence Data Architect for 20 years and has over 25 years of technical experience in relational and dimensional database technologies.  He is currently a Data Architect at Innerspace in Innsbruck, Austria. He has been a developer, architect, analyst and educator in a variety of vertical markets and technologies.  Frank has also been a consultant to Fortune 500 and mid-market companies in the use and implementation of data warehouse architectures, unstructured data, metadata management and analytic presentation.\r\n\r\nFrank is a 2018 and 2020 IBM Champion for Cloud and Blockchain, and was a 2014 IBM Champion for Information Management. He continues to provide thought leadership and research in such diverse areas as Streaming Data, Blockchain, Modern Data Architecture and Cloud Computing. Frank is also a public speaker and author on topics related to Business Intelligence, disruptive technologies, mobile computing and software methodologies and is also a member of the Digitale Initiativen in Dornbirn, Austria. \r\n",
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/frank-blau/",
					},
					// pixels: [
					// 	"p2tlv",
					// 	"p1br",
					// 	"p0tr2"
					// ]
				},
				"bogovic-dubravko": {
					visible: true,
					placeholder: false,
					image: "bogovic-dubravko.jpg",
					name: "Dubravko",
					surname: "Bogović",
					contact: {
						email: "dubravko.bogovic@gmail.com",
					},
					position: {
						hr: "Adventuring in cyberspace",
						en: "Adventuring in cyberspace",
					},
					bio: {
						hr: "I am an electrical engineer turned programmer. I love new technologies, smart homes and renewable energy as well as Science Fiction and fantasy and board games. I love making quizzes for conventions and playing board game tournaments or just attending a game day. \r\nAlso love badminton and everything related to it. ",
						en: "I am an electrical engineer turned programmer. I love new technologies, smart homes and renewable energy as well as Science Fiction and fantasy and board games. I love making quizzes for conventions and playing board game tournaments or just attending a game day. \r\nAlso love badminton and everything related to it. ",
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/dbogovic",
					},
					// pixels: [
					// 	"p4tr",
					// 	"p1bl"
					// ]
				},
				"cindric-gordon": {
					visible: true,
					placeholder: false,
					image: "cindric-gordon.png",
					name: "Gordon",
					surname: "Cindrić",
					contact: {
						email: "gordon@mcknightmedia.co",
					},
					position: {
						hr: "CEO & Lead Product Designer @ McKnight Media",
						en: "CEO & Lead Product Designer @ McKnight Media",
					},
					bio: {
						hr: "Gordon is an experience product designer, team leader and mentor who spent over 15 years designing UX for countless digital products of all types and sizes. For the last 5 years, he's been building a niche design agency specialized in designing UX for complex, domain-specific, enterprise software. McKnight Media has also recently expanded it's activities to include product management and B2B UX training for non-designers.",
						en: "Gordon is an experience product designer, team leader and mentor who spent over 15 years designing UX for countless digital products of all types and sizes. For the last 5 years, he's been building a niche design agency specialized in designing UX for complex, domain-specific, enterprise software. McKnight Media has also recently expanded it's activities to include product management and B2B UX training for non-designers.",
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/gordoncindric/",
					},
					// pixels: [
					// 	"p2trh",
					// 	"p4bl"
					// ]
				},
				"jonas-miroslav": {
					visible: true,
					placeholder: false,
					image: "jonas-miroslav.jpg",
					name: "Miroslav",
					surname: "Jonaš",
					contact: {
						email: "missing.manual@gmail.com",
					},
					position: {
						hr: "Senior Developer Productivity Engineer @ Nx",
						en: "Senior Developer Productivity Engineer @ Nx",
					},
					bio: {
						hr: "Miro is a Senior Developer Productivity Engineer and a Core member of the Nx team. He's helping customers build scalable and performant applications with warp-speed CI. He is based in Vienna where he co-founded Angular Austria and co-organizes the Vienna JS meetup. Father of two, husband of one, not a visual collaboration platform.",
						en: "Miro is a Senior Developer Productivity Engineer and a Core member of the Nx team. He's helping customers build scalable and performant applications with warp-speed CI. He is based in Vienna where he co-founded Angular Austria and co-organizes the Vienna JS meetup. Father of two, husband of one, not a visual collaboration platform.",
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/meeroslav",
					},
				},
				"kladaric-luka": {
					visible: true,
					placeholder: false,
					keynote: true,
					image: "kladaric-luka.jpg",
					name: "Luka",
					surname: "Kladarić",
					contact: {
						email: "luka@chaos.guru",
					},
					position: {
						hr: "Chaos guru",
						en: "Chaos guru",
					},
					bio: {
						hr: "A former web developer turned architecture, infrastructure & security consultant. Also a remote work evangelist.",
						en: "A former web developer turned architecture, infrastructure & security consultant. Also a remote work evangelist.",
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/lukakladaric/",
					},
				},
				"kofjac-dalibor": {
					visible: true,
					placeholder: false,
					image: "kofjac-dalibor.jpg",
					name: "Dalibor",
					surname: "Kofjač",
					contact: {
						email: "dadolg22@gmail.com",
					},
					position: {
						hr: "WebRTC Specialist | Senior Software Developer @ Span d.d.",
						en: "WebRTC Specialist | Senior Software Developer @ Span d.d.",
					},
					bio: {
						hr: "An experienced software developer with a Master’s degree in Information Science and Computer Programming. Worked on the planning and development of several different business software solutions, from large enterprise applications, to real-time web communication systems. Specialized in building and optimizing web and native WebRTC solutions. Mainly uses .NET with Angular for web development, (native) Android for mobile development and Microsoft Azure for cloud services.",
						en: "An experienced software developer with a Master’s degree in Information Science and Computer Programming. Worked on the planning and development of several different business software solutions, from large enterprise applications, to real-time web communication systems. Specialized in building and optimizing web and native WebRTC solutions. Mainly uses .NET with Angular for web development, (native) Android for mobile development and Microsoft Azure for cloud services.",
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/dalibor-kofjac/",
					},
				},
				// "levacic-filip": {
				// 	visible: false,
				// 	placeholder: false,
				// 	image: "levacic-filip.jpg",
				// 	name: "Filip",
				// 	surname: "Levačić",
				// 	contact: {
				// 		email: "levacic1995@gmail.com",
				// 	},
				// 	position: {
				// 		hr: "Senior Software Developer @ Codebooq",
				// 		en: "Senior Software Developer @ Codebooq",
				// 	},
				// 	bio: {
				// 		hr: "An experienced software developer, from .NET backend, Angular and React frontend, to cloud and mobile. Loves working in large teams and knowledge sharing with his colleagues, mentoring students and doing both internal and conference talks. Loves units tests, readable code and interesting question at pub quizzes, even if he doesn't know the answer. Hates the trend of mentioning the Terminator in every discussion about AI.",
				// 		en: "An experienced software developer, from .NET backend, Angular and React frontend, to cloud and mobile. Loves working in large teams and knowledge sharing with his colleagues, mentoring students and doing both internal and conference talks. Loves units tests, readable code and interesting question at pub quizzes, even if he doesn't know the answer. Hates the trend of mentioning the Terminator in every discussion about AI.",
				// 	},
				// 	social: {
				// 		linkedIn: "https://www.linkedin.com/in/filiplevacic/",
				// 	},
				// },
				"logozar-anja": {
					visible: true,
					placeholder: false,
					image: "logozar-anja.png",
					name: "Anja",
					surname: "Logožar",
					contact: {
						email: "anja@mcknightmedia.co",
					},
					position: {
						hr: "UX designer @ McKnight Media",
						en: "UX designer @ McKnight Media",
					},
					bio: {
						hr: null,
						en: "UX designer with five years of experience specializing in design systems, process optimization, and the development of complex enterprise products. Through working with teams from diverse industries, she has developed a clear understanding of challenges that can slow down processes and product development. Actively advocates for UX principles and speaks about their impact on products, user experience, business outcomes, and team collaboration.",
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/anjalogozar/",
					},
				},
				"matijanic-borna": {
					visible: true,
					placeholder: false,
					image: "matijanic-borna-2025.jpg",
					name: "Borna",
					surname: "Matijanić",
					contact: {
						email: "borna.m@netgen.io",
					},
					position: {
						hr: "Backend team lead @ Netgen",
						en: "Backend team lead @ Netgen",
					},
					bio: {
						hr: "Backend Team Leader and Branch manager @Netgen. PHP/Symfony developer, graduated Informatics at Faculty of Electrical Engineering, Computer Science and Information Technology Osijek. Doing web stuff for 7 years. Besides arranging ones and zeros into request and response, loves to speak at conferences and organizes local PHP meetup. Slavonia evangelist.",
						en: "Backend Team Leader and Branch manager @Netgen. PHP/Symfony developer, graduated Informatics at Faculty of Electrical Engineering, Computer Science and Information Technology Osijek. Doing web stuff for 7 years. Besides arranging ones and zeros into request and response, loves to speak at conferences and organizes local PHP meetup. Slavonia evangelist.",
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/borna-matijani%C4%87-6007b992/",
					},
				},
				"safaric-miroslav": {
					visible: true,
					placeholder: false,
					image: "safaric-miroslav.jpeg",
					name: "Miroslav",
					surname: "Šafarić",
					contact: {
						email: "miroslav.safaric@gmail.com",
					},
					position: {
						hr: "Senior platform engineer @ Castor",
						en: "Senior platform engineer @ Castor",
					},
					bio: {
						hr: "Technical experience in designing, building, and managing platforms on public and private cloud infrastructure. Focus on improving software delivery and developer experience, through building internal tooling and combining it with open source tools, to provide a self serving platform for developers to consume and improve their productivity. \r\n\r\nExtensive knowledge of Linux system administration and Kubernetes ecosystem with a focus on observability, security, and creating high-quality technical documentation.",
						en: "Technical experience in designing, building, and managing platforms on public and private cloud infrastructure. Focus on improving software delivery and developer experience, through building internal tooling and combining it with open source tools, to provide a self serving platform for developers to consume and improve their productivity. \r\n\r\nExtensive knowledge of Linux system administration and Kubernetes ecosystem with a focus on observability, security, and creating high-quality technical documentation.",
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/msafaric",
					},
				},
				"sajcic-stella": {
					visible: true,
					placeholder: false,
					image: "sajcic-stella.jpg",
					name: "Stella",
					surname: "Sajčić",
					contact: {
						email: "sajcic.stella@gmail.com",
					},
					position: {
						hr: "Full stack web engineer @ SimpleApproach",
						en: "Full stack web engineer @ SimpleApproach",
					},
					bio: {
						hr: "5 years of experience working as a freelancer for EU companies as a full-stack web engineer, specializing in creating custom UI libraries that follow design systems and support accessibility.",
						en: "5 years of experience working as a freelancer for EU companies as a full-stack web engineer, specializing in creating custom UI libraries that follow design systems and support accessibility.",
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/ssajcic",
					},
				},
				"zagorscak-bruno": {
					visible: true,
					placeholder: false,
					image: "zagorscak-bruno.jpg",
					name: "Bruno",
					surname: "Zagorščak",
					contact: {
						email: "bruno@neuralab.net",
					},
					position: {
						hr: "Chief Content @ Neuralab",
						en: "Chief Content @ Neuralab",
					},
					bio: {
						hr: "Bruno Zagorščak is a content maker, videographer, and live-stream producer. He's Chief Content Officer and co-founder of Neuralab, a full-service team of creative people, managing all aspects of online eCommerce projects. He has nearly two decades of experience creating content across multiple mediums, including video, audio, photography, and text. His role at Neuralab involves leading content creation, often focusing on engaging user experiences. Bruno is also known for his expertise producing interactive content and directing live broadcasts, as well as his participation in various podcasts and webinars related to the tech industry.",
						en: "Bruno Zagorščak is a content maker, videographer, and live-stream producer. He's Chief Content Officer and co-founder of Neuralab, a full-service team of creative people, managing all aspects of online eCommerce projects. He has nearly two decades of experience creating content across multiple mediums, including video, audio, photography, and text. His role at Neuralab involves leading content creation, often focusing on engaging user experiences. Bruno is also known for his expertise producing interactive content and directing live broadcasts, as well as his participation in various podcasts and webinars related to the tech industry.",
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/bzagor/",
					},
				},
			},
			sessions: [
				{
					visible: true,
					placeholder: false,
					ident: "thriving-without-burning-out",
					duration: 45,
					type: "talk",
					language: "en",
					level: "novice",
					code: "none",
					title: {
						hr: "",
						en: "13 Years Remote: Thriving as a Web Developer Without Burning Out",
					},
					description: {
						hr: "",
						en: "What does a sustainable, successful remote career look like for a web developer? After 13+ years working remotely in full-stack web development, I’ve learned what works—and what really doesn’t. This talk offers practical strategies for staying productive, growing your skills, and staying competitive in a fast-changing field, all while maintaining boundaries and avoiding burnout. We’ll cover tools, workflows, negotiation tips, and how to choose the right kinds of projects—plus the realities (good and bad) of long-term remote life in web development.",
					},
					speakers: ["begedin-nikola"],
				},
				{
					visible: true,
					placeholder: false,
					ident: "unlocking-actionable-insights-property-graph-databases",
					duration: 45,
					type: "talk",
					language: "en",
					level: "intermediate",
					code: "light",
					title: {
						hr: "Unlocking Actionable Insights: Property Graph Databases",
						en: "Unlocking Actionable Insights: Property Graph Databases",
					},
					description: {
						hr: "Explore how property graph databases revolutionize the way we analyze and leverage complex relationships in data. By combining the fundamentals of graph theory with real-world applications, this session demonstrates why graph databases are an essential tool for modern analytics. Attendees will learn about key features, practical use cases like social networks, fraud detection, and recommendation systems, and see a live demonstration of graph querying and visualization techniques. This presentation is ideal for data professionals, developers, and decision-makers looking to harness the potential of graph-driven insights in their projects.",
						en: "Explore how property graph databases revolutionize the way we analyze and leverage complex relationships in data. By combining the fundamentals of graph theory with real-world applications, this session demonstrates why graph databases are an essential tool for modern analytics. Attendees will learn about key features, practical use cases like social networks, fraud detection, and recommendation systems, and see a live demonstration of graph querying and visualization techniques. This presentation is ideal for data professionals, developers, and decision-makers looking to harness the potential of graph-driven insights in their projects.",
					},
					speakers: ["blau-frank"],
				},
				{
					visible: true,
					placeholder: false,
					ident: "transforming-developer-experience-from-challenges-to-excellence",
					duration: 45,
					type: "talk",
					language: "en",
					level: "intermediate",
					code: "none",
					title: {
						hr: "Transforming Developer Experience from Challenges to Excellence",
						en: "Transforming Developer Experience from Challenges to Excellence",
					},
					description: {
						hr: "In the fast-paced world of software development, the experience of the developer is a crucial factor that significantly impacts productivity, job satisfaction, and overall workflow efficiency. This tech talk will delve into the multifaceted importance of developer experience (DevEx) and explore strategies to enhance it. We will discuss how optimizing workflows, ensuring ease of work, and maintaining a clear separation of responsibilities can lead to happier and more productive developers. Additionally, we will highlight the mental relief that comes from a well-setup development environment compared to the chaos of an unstructured one. Join us to learn how to create a thriving development culture that not only meets business goals but also keeps developers motivated and satisfied.",
						en: "In the fast-paced world of software development, the experience of the developer is a crucial factor that significantly impacts productivity, job satisfaction, and overall workflow efficiency. This tech talk will delve into the multifaceted importance of developer experience (DevEx) and explore strategies to enhance it. We will discuss how optimizing workflows, ensuring ease of work, and maintaining a clear separation of responsibilities can lead to happier and more productive developers. Additionally, we will highlight the mental relief that comes from a well-setup development environment compared to the chaos of an unstructured one. Join us to learn how to create a thriving development culture that not only meets business goals but also keeps developers motivated and satisfied.",
					},
					speakers: ["bogovic-dubravko"],
				},
				{
					visible: true,
					placeholder: false,
					ident: "pixel-pushing-or-problem-solving-making-ux-work-in-agile",
					duration: 45,
					type: "talk",
					language: "en",
					level: "intermediate",
					code: "none",
					title: {
						hr: "Pixel Pushing or Problem Solving? Making UX Work in Agile",
						en: "Pixel Pushing or Problem Solving? Making UX Work in Agile",
					},
					description: {
						hr: "",
						en: "Teams often struggle with integrating UX into Agile development, often reducing it to an afterthought or drowning it in rigid SCRUM rituals. This talk explores how to raise UX maturity in your team—whether you're starting from zero or looking to refine your approach—without inflating budgets or timelines.\r\n\r\nWe'll share real-world experiences from years of product design work, highlighting the top pitfalls that derail UX efforts in Agile teams, and practical strategies to avoid them.\r\n\r\nWe'll discuss:\r\n- How to effectively collaborate with UX designers and avoid “solutioneering”\r\n- How to give UX teams the right input at the right time for maximum impact\r\n- How to keep the process user-centered instead of pure assumption-driven\r\n- How to optimize Agile workflows for better UX outcomes\r\n- How UX can improve the QA process\r\n- How to ensure UX work and communication is transparent\r\n\- How to navigate organizational politics, even when stakeholders resist change or misunderstand the value of UX.\r\n\r\nThis session is designed for product owners and team leads who want to enhance their UX processes, make smarter product decisions, and ultimately create better user experiences—all while keeping business goals in focus. Designers can also learn about managing workload and influence, navigating challenges, keeping burnout at bay, and thriving in cross-functional teams.",
					},
					speakers: ["cindric-gordon", "logozar-anja"],
				},
				{
					visible: true,
					placeholder: false,
					ident: "the-dark-art-of-code-optimization",
					duration: 30,
					type: "talk",
					language: "en",
					level: "intermediate",
					code: "light",
					title: {
						hr: "The Dark Art of Code Optimization",
						en: "The Dark Art of Code Optimization",
					},
					description: {
						hr: 'Performance topic is very trendy right now. Chance is you already heard it - use lazy loading, prefetch everything with partially hydrated server-side rendered static islands. Ship zero bytes of JavaScript! But what if your code is not running in the browser or your performance is bad at runtime?\r\n\r\nThis talk will share several (un)conventional tricks you can apply to speed up the application when the size of your data grows. I will show you how to measure performance and squeeze out those last excessive milliseconds.\r\n\r\nLearn how usual "bad practices" can become your ally when battling performance.',
						en: 'Performance topic is very trendy right now. Chance is you already heard it - use lazy loading, prefetch everything with partially hydrated server-side rendered static islands. Ship zero bytes of JavaScript! But what if your code is not running in the browser or your performance is bad at runtime?\r\n\r\nThis talk will share several (un)conventional tricks you can apply to speed up the application when the size of your data grows. I will show you how to measure performance and squeeze out those last excessive milliseconds.\r\n\r\nLearn how usual "bad practices" can become your ally when battling performance.',
					},
					speakers: ["jonas-miroslav"],
				},
				{
					visible: true,
					placeholder: false,
					keynote: true,
					ident: "why-are-databases-so-difficult",
					duration: 45,
					type: "talk",
					language: "en",
					level: "novice",
					code: "none",
					title: {
						hr: null,
						en: "Why are databases so 🤬 difficult?!",
					},
					description: {
						hr: null,
						en: [
							"<p>Shipping an application has never been easier, but what good is an application without state?</p>",
							"<p>Like it or not, we deal with databases all day, every day, and the majority of outages and incidents come from some sort of database. Relational databases remain the very foundation of software development despite a continuous onslaught of alternatives, and regularly make our lives quite miserable. Databases, no matter their flavor, obey a known set of hard limitations, but the understanding of those has become almost arcane knowledge as the barrier to entry in software development keeps dropping.</p>",
							"<p>Let's shed some modern perspective light on these mythical beasts and help you scale your apps with ease.</p>",
						],
					},
					speakers: ["kladaric-luka"],
				},
				{
					visible: true,
					placeholder: false,
					ident: "video-chat-with-augmented-reality",
					duration: 45,
					type: "talk",
					language: "en",
					level: "novice",
					code: "light",
					title: {
						hr: "Video chat with Augmented Reality",
						en: "Video chat with Augmented Reality",
					},
					description: {
						hr: "The research and development of Augmented Reality (AR), along with the exploration of its most practical applications, have become highly popular topics among IT professionals in recent years. While the gaming industry has primarily focused on AR applications for smartphones, such as Pokémon GO, the business sector is increasingly embracing smart glasses as the most effective medium for integrating AR across various industries.\r\n\r\nIn this lecture, we will start with a brief introduction to Augmented Reality, exploring its current use in the business world and the growing role of AR smart glasses in this evolving field. The main, technical part of the presentation will delve into the technologies used to develop AR applications, concluding with a practical demo of building a fully functional video chat app designed for seamless use across various modern AR smart glasses.",
						en: "The research and development of Augmented Reality (AR), along with the exploration of its most practical applications, have become highly popular topics among IT professionals in recent years. While the gaming industry has primarily focused on AR applications for smartphones, such as Pokémon GO, the business sector is increasingly embracing smart glasses as the most effective medium for integrating AR across various industries.\r\n\r\nIn this lecture, we will start with a brief introduction to Augmented Reality, exploring its current use in the business world and the growing role of AR smart glasses in this evolving field. The main, technical part of the presentation will delve into the technologies used to develop AR applications, concluding with a practical demo of building a fully functional video chat app designed for seamless use across various modern AR smart glasses.",
					},
					speakers: ["kofjac-dalibor"],
				},
				// {
				// 	visible: false,
				// 	placeholder: false,
				// 	ident: "clean-code-in-practice",
				// 	duration: 45,
				// 	type: "talk",
				// 	language: "en",
				// 	level: "intermediate",
				// 	code: "heavy",
				// 	title: {
				// 		hr: "Clean Code in practice",
				// 		en: "Clean Code in practice",
				// 	},
				// 	description: {
				// 		hr: "„Clean code“ is an ever-present term in software development, often presented as an unatainable holy grail that only nit-picky developers care about. Clean code is often thought as a long list of rules to follow, so it is often sidelined or ignored entirely.\r\n\tWithout a clear understaing of the actual reasons clean code is important, and the very real problems the absence of maintainable code can lead to, software developers mix various guidelines, best practices and personal experience and education, which does not lead to a clean and readable codebase.\r\n\tIn this talk, I will talk about another way to understand and teach clean code. Rather than going through a list of practices to follow, this talk will present actual problems that bad code lead to, the consequences that followed, and how they were solved, all presented via code. This talk will also touch upon something not often discussed when it comes to clean code – how to effectively teach it to others.",
				// 		en: "„Clean code“ is an ever-present term in software development, often presented as an unatainable holy grail that only nit-picky developers care about. Clean code is often thought as a long list of rules to follow, so it is often sidelined or ignored entirely.\r\n\tWithout a clear understaing of the actual reasons clean code is important, and the very real problems the absence of maintainable code can lead to, software developers mix various guidelines, best practices and personal experience and education, which does not lead to a clean and readable codebase.\r\n\tIn this talk, I will talk about another way to understand and teach clean code. Rather than going through a list of practices to follow, this talk will present actual problems that bad code lead to, the consequences that followed, and how they were solved, all presented via code. This talk will also touch upon something not often discussed when it comes to clean code – how to effectively teach it to others.",
				// 	},
				// 	speakers: ["levacic-filip"],
				// },
				{
					visible: true,
					placeholder: false,
					ident: "technical-debt-autopsy-real-world-lessons-from-rescuing-challenging-projects",
					duration: 30,
					type: "talk",
					language: "en",
					level: "intermediate",
					code: "light",
					title: {
						hr: "Technical Debt Autopsy: Real-world Lessons from Rescuing Challenging Projects",
						en: "Technical Debt Autopsy: Real-world Lessons from Rescuing Challenging Projects",
					},
					description: {
						hr: "A deep dive into the trenches of software engineering, revealing how teams can diagnose, strategically refactor, and resurrect legacy codebases plagued by technical debt. Learn from real-world case studies that showcase diagnostic techniques, pragmatic improvement strategies, and the art of transforming complex, inherited systems into maintainable, efficient software architectures. \r\n\r\nExplore proven methodologies for untangling intricate code dependencies, identifying architectural vulnerabilities, and implementing incremental improvements without disrupting critical business operations. Gain insights from experienced engineers who have successfully navigated the treacherous landscape of legacy system rehabilitation, turning technical challenges into opportunities for sustainable software evolution.",
						en: "A deep dive into the trenches of software engineering, revealing how teams can diagnose, strategically refactor, and resurrect legacy codebases plagued by technical debt. Learn from real-world case studies that showcase diagnostic techniques, pragmatic improvement strategies, and the art of transforming complex, inherited systems into maintainable, efficient software architectures. \r\n\r\nExplore proven methodologies for untangling intricate code dependencies, identifying architectural vulnerabilities, and implementing incremental improvements without disrupting critical business operations. Gain insights from experienced engineers who have successfully navigated the treacherous landscape of legacy system rehabilitation, turning technical challenges into opportunities for sustainable software evolution.",
					},
					speakers: ["matijanic-borna"],
				},
				{
					visible: true,
					placeholder: false,
					ident: "5-elasticsearch-failure-stories-and-lessons-learned",
					duration: 45,
					type: "talk",
					language: "en",
					level: "intermediate",
					code: "none",
					title: {
						hr: "5 Elasticsearch failure stories and lessons learned",
						en: "5 Elasticsearch failure stories and lessons learned",
					},
					description: {
						hr: 'Practical Lessons from the Real World: Challenges, Anecdotes, and Insights on Working with Elasticsearch\r\n\r\nThis talk takes you through real stories, challenges, and anecdotes from working with the Elasticsearch. Instead of focusing on theory, the emphasis is on practical experiences - the unexpected situations that arise in real-world project work. \r\nThrough these examples, we won’t just learn about Elasticsearch as a tool, but also draw broader lessons applicable to software development and problem-solving in general.\r\n\r\nOne key topic will be the danger of relying on default settings. Too often, in the rush of development, we leave default configurations in place, assuming they will be "good enough." I’ll share a concrete example where default settings led to unexpected issues.\r\n\r\nAnother crucial aspect I’ll highlight is that good architecture doesn’t automatically mean the system will work as expected. An architecture might look perfect on paper, with well-structured components and best practices in place, but under real-world load and unforeseen usage patterns, things can start to break down.\r\n\r\nThe third key point of this talk is the importance of periodically re-evaluating system architecture and configurations. Systems and their requirements evolve - what worked six months ago may no longer be optimal today.\r\nWe’ll go through cases where neglecting regular system reviews proved to be a costly mistake, and discuss how to avoid blaming the tool alone, how to critically assess our own solutions, and why we shouldn’t fear stepping back to reassess fundamental decisions.\r\n\r\nWhether you’re a developer, architect, or someone responsible for system maintenance, this talk will provide valuable insights and practical advice to help you avoid the pitfalls we encountered - or at least recognize them more easily when you do.',
						en: 'Practical Lessons from the Real World: Challenges, Anecdotes, and Insights on Working with Elasticsearch\r\n\r\nThis talk takes you through real stories, challenges, and anecdotes from working with the Elasticsearch. Instead of focusing on theory, the emphasis is on practical experiences - the unexpected situations that arise in real-world project work. \r\nThrough these examples, we won’t just learn about Elasticsearch as a tool, but also draw broader lessons applicable to software development and problem-solving in general.\r\n\r\nOne key topic will be the danger of relying on default settings. Too often, in the rush of development, we leave default configurations in place, assuming they will be "good enough." I’ll share a concrete example where default settings led to unexpected issues.\r\n\r\nAnother crucial aspect I’ll highlight is that good architecture doesn’t automatically mean the system will work as expected. An architecture might look perfect on paper, with well-structured components and best practices in place, but under real-world load and unforeseen usage patterns, things can start to break down.\r\n\r\nThe third key point of this talk is the importance of periodically re-evaluating system architecture and configurations. Systems and their requirements evolve - what worked six months ago may no longer be optimal today.\r\nWe’ll go through cases where neglecting regular system reviews proved to be a costly mistake, and discuss how to avoid blaming the tool alone, how to critically assess our own solutions, and why we shouldn’t fear stepping back to reassess fundamental decisions.\r\n\r\nWhether you’re a developer, architect, or someone responsible for system maintenance, this talk will provide valuable insights and practical advice to help you avoid the pitfalls we encountered - or at least recognize them more easily when you do.',
					},
					speakers: ["safaric-miroslav"],
				},
				{
					visible: true,
					placeholder: false,
					ident: "wcag",
					duration: 30,
					type: "talk",
					language: "en",
					level: "novice",
					code: "light",
					title: {
						hr: "Web Accessibility: The Importance of Tomorrow, Overcoming Challenges with Ease",
						en: "Web Accessibility: The Importance of Tomorrow, Overcoming Challenges with Ease",
					},
					description: {
						hr: "I will introduce the growing importance of web accessibility today, both as a brand and as a web specialist. I’ll highlight key accessibility cases that are often overlooked by developers and businesses, despite their significance. Additionally, we will briefly cover essential tools and I will share my personal experience applying WCAG standards to a popular Irish website with 300k monthly visitors, offering practical tips for integrating accessibility into your projects.",
						en: "I will introduce the growing importance of web accessibility today, both as a brand and as a web specialist. I’ll highlight key accessibility cases that are often overlooked by developers and businesses, despite their significance. Additionally, we will briefly cover essential tools and I will share my personal experience applying WCAG standards to a popular Irish website with 300k monthly visitors, offering practical tips for integrating accessibility into your projects.",
					},
					speakers: ["sajcic-stella"],
				},
				{
					visible: true,
					placeholder: false,
					ident: "beasts-of-burden-how-motion-design-transforms-ux",
					duration: 30,
					type: "talk",
					language: "en",
					level: "intermediate",
					code: "light",
					title: {
						hr: "Beasts of burden: How motion design transforms UX",
						en: "Beasts of burden: How motion design transforms UX",
					},
					description: {
						hr: "This session explores the transformative power of animations in modern web design, offering a deep dive into their ability to enhance user experience, strengthen brand identity, and drive website performance. Attendees will learn about the strategic use of animations to improve navigation, guide user focus, and boost conversions—particularly in e-commerce contexts. The talk also addresses common pitfalls, such as poorly optimized animations that can harm load times and SEO, and provides actionable solutions.",
						en: "This session explores the transformative power of animations in modern web design, offering a deep dive into their ability to enhance user experience, strengthen brand identity, and drive website performance. Attendees will learn about the strategic use of animations to improve navigation, guide user focus, and boost conversions—particularly in e-commerce contexts. The talk also addresses common pitfalls, such as poorly optimized animations that can harm load times and SEO, and provides actionable solutions.",
					},
					speakers: ["zagorscak-bruno"],
				},
			],
			schedule: [
				{
					// registration
					duration: 60,
					special: true,
					doNotEvaluate: true,
					skipOnSurvey: true,
					language: "en",
					title: {
						hr: "Registracija, kava i doručak",
						en: "Registration, Coffee & Breakfast",
					},
					description: {
						hr: [],
						en: [
							"<p>Gather, register and get your goodie bag.</p>",
							"<p>Enjoy your morning with coffee from cWebSpace and breakfast from Full Circle.<br/>",
							"Breakfast will be available until 11:00, so no stress if you're not an early bird.</p>"
						]
					},
					// poweredBy: {
					// 	name: "cWebSpace & Full Circle"
					// }
				},
				{
					// opening ceremony / welcome note
					duration: 10,
					special: true,
					doNotEvaluate: true,
					skipOnSurvey: true,
					language: "en",
					title: {
						hr: "Otvaranje konferencije",
						en: "Conference Opening",
					},
					description: {
						hr: [],
						en: "Quick welcome note and then we move on.",
					},
					moderators: []
				},
				TRACK_BREAK(5),
				{
					session: "why-are-databases-so-difficult",
				},
				TRACK_BREAK(),
				{
					session: "transforming-developer-experience-from-challenges-to-excellence",
				},
				TRACK_BREAK(),
				{
					session: "pixel-pushing-or-problem-solving-making-ux-work-in-agile",
				},
				TRACK_BREAK(),
				{
					session: "the-dark-art-of-code-optimization",
				},
				TRACK_BREAK(),
				{
					session: "5-elasticsearch-failure-stories-and-lessons-learned",
				},
				LUNCH_BREAK(),
				{
					session: "unlocking-actionable-insights-property-graph-databases",
				},
				TRACK_BREAK(),
				{
					session: "thriving-without-burning-out"
				},
				TRACK_BREAK(),
				{
					session: "video-chat-with-augmented-reality",
				},
				TRACK_BREAK(),
				{
					session: "wcag",
				},
				TRACK_BREAK(),
				{
					session: "technical-debt-autopsy-real-world-lessons-from-rescuing-challenging-projects",
				},
				TRACK_BREAK(),
				{
					session: "beasts-of-burden-how-motion-design-transforms-ux",
				},
				{
					// AFTER PARTY
					visible: true,
					special: true,
					doNotEvaluate: true,
					// skipOnSurvey: true,
					placeholder: false,
					special: true,
					ident: "after-party",
					duration: 180,
					title: {
						hr: "Večera i završna fešta",
						en: "Dinner & After Party",
					},
					description: {
						hr: "",
						en: "Start with dinner from Full Circle, followed by music, drinks and easy-going social time.",
					},
					// poweredBy: {
					// 	name: "Full Circle"
					// }
				},
			],
			faq: {
				hr: [
					{
						title: "Što je Weblica?",
						short: "",
						full: "Weblica je konferencija posvećena web tehnologijama i IT sektoru koja okuplja različite stručnjake i entuzijaste iz cijele regije.",
					},
					{
						title: "Gdje i kada će se održati Weblica {{currentYear}}?",
						short: "",
						full: [
							"Weblica {{currentYear}} održat će se {{eventDate}} s početkom u {{eventTime}} sati.<br/>",
							"Adresa: {{venueNameAndAddress}}<br/><br/>",
							"Pronađi lokaciju <a href='{{mapUrl}}' target='_blank'>na ovoj karti</a>.",
						],
					},
					{
						title: "Kako se prijaviti za sudjelovanje kao predavač na Weblici i koji je rok za prijavu?",
						short: "",
						full: [
							`Prijave za predavače završavaju {{lectureRegistration.to}} u ponoć, a prijaviti se možete putem <a href='{{sessionsUrl}}' target='_blank'>Sessionize platforme</a>`,
						],
					},
					{
						title: "Koji su glavni sadržaji konferencije?",
						short: "",
						full: "Konferencija obuhvaća  razna predavanja, radionice i panel diskusije o najnovijim trendovima i temama u web tehnologijama.",
					},
					{
						title: "Koja je ciljna publika Weblice?",
						short: "",
						full: "Weblica okuplja stručnjake iz IT sektora, developere, programere, dizajnere, poduzetnike te sve koji su strastveni prema web tehnologijama.",
					},
					{
						title: "Kako mogu postati sponzor Weblice?",
						short: "",
						full: "Ako ste zainteresirani za sponzorstvo, pošaljite nam upit <a href='/{{linkLang}}/sponsors'>korištenjem ove forme.</a>",
					},
					{
						title: "Je li sudjelovanje na Weblici besplatno?",
						short: "",
						full: "Nažalost ne, ali cijene su iznimno pristupačne. Više informacija možete saznati na <a href='/{{linkLang}}/{{event}}/#tickets'>ovdje</a>.",
					},
					{
						title: "Trebam li imati tehničko predznanje za sudjelovanje na konferenciji?",
						short: "",
						full: "Weblica je namijenjena različitim razinama znanja, tako da i početnici i oni iskusniji mogu pronaći relevantne sadržaje.",
					},
					{
						title: "Kako mogu volontirati na konferenciji?",
						short: "",
						full: "Volonteri su i više nego dobro došli. Ako si zainteresiran(a) za sudjelovanje kao volonter, <a href='/{{linkLang}}/volunteer'>popuni ovu formu</a>.",
					},
					{
						title: "Hoće li negdje biti omogućeno parkirati automobil?",
						short: "",
						full: "Da, omogućen je besplatan parking.",
					},
				],
				en: [
					{
						title: "What is Weblica?",
						short: "",
						full: "Weblica is a conference dedicated to web technologies and the IT sector that brings together various experts and enthusiasts from the entire region.",
					},
					{
						title: "Do I need to have technical background to participate?",
						short: "",
						full: "Our conference is designed for attendees of all knowledge levels. We select sessions that are accessible to a broader audience, but also include advanced topics for more experienced participants. Each session is labeled with the required knowledge level, so you’ll know in advance if it’s beginner-friendly or more suited to experts.",
					},
					{
						title: "Where and when will Weblica {{currentYear}} be held?",
						short: "",
						full: [
							"<p>Weblica {{currentYear}} will be held on <b>{{eventDate}}</b>, starting at {{eventTime}}.<br/>",
							"It will be held at <a href='/{{event}}/{{linkLang}}#venue'><b>{{venueName}}</b></a><b>, {{venueAddress}}</b>.</p>",
						],
					},
					{
						title: "How to apply for participation as a speaker and what is the application deadline?",
						short: "",
						full: `Applications for speakers end on {{lectureRegistration.to}} at midnight, and you can register via <a href='{{sessionsUrl}}' target='_blank'>Sessionize platform</a>`,
					},
					{
						title: "What is the target audience?",
						short: "",
						full: "Weblica brings together experts from the IT sector, developers, programmers, designers, entrepreneurs and everyone who is passionate about web technologies.",
					},
					{
						title: "How can I become a sponsor?",
						short: "",
						full: "If you are interested in sponsorship, please send us an inquiry <a href='{{urlPrefix}}/{{linkLang}}/sponsors'>using this form.</a>",
					},
					{
						title: "How can I volunteer at the conference?",
						short: "",
						full: "Volunteers are more than welcome. If you are interested in participating, please <a href='{{urlPrefix}}/{{linkLang}}/volunteer'>use this form</a>.",
					},
					{
						title: "Is participation free of charge?",
						short: "",
						full: "Unfortunately not. <a href='{{urlPrefix}}/{{linkLang}}/{{event}}/#tickets'>Check out the tickets</a>",
					},
					{
						title: "Can I get a refund if I can not longer attend?",
						short: "",
						full: "No, we do not provide refunds, but we can authorize ticket transfer.<br/>Please contact us at <a href='mailto:info@weblica.hr' targget='_blank'>info@weblica.hr</a>.",
					},
					// {
					// 	title: "How can I access Worklica workshops?",
					// 	short: "",
					// 	full: [
					// 		"All Weblica tickets give you access to workshops, but you need to register in order to secure your spot on specific workshop(s)."
					// 	]
					// },
					{
						title: "Will it be possible to park a car somewhere?",
						short: "",
						full: "Yes, free parking is available.",
					},
					// {
					// 	title: "x",
					// 	short: "",
					// 	full: ""
					// },
				],
			},
			news: {
				en: [
					{
						title: "Black Friday Offer",
						when: "2024-11-28",
						startDate: "2024-11-28 00:00:00",
						endDate: "2024-12-07 23:59:59",
						breaking: true,
						full: [
							"<p>Use promo code <b>BlackFridayWEBLICA</b> to get 20% off early bird tickets!<br/>",
							"Offer valid until December 7th, 2024.</p>",
							"<p><a href='#tickets'>Get Tickets</a></p>",
						],
					},
					{
						// title: "Hop on the Weblica bus!",
						when: "2025-05-05",
						startDate: "2025-05-05 00:00:00",
						endDate: "2025-05-09 23:59:59",
						breaking: true,
						fullBlocks: [
							{
								width: "third",
								image: {
									file: "weblica-bus.jpg",
									alt: "weblica-bus"
								}
							},
							{
								width: "twothirds",
								text: [
									"<p>On May 9th, we’re organizing free bus rides for all Weblica 2025 attendees:<p>",
									"<p>→ Departure from Varaždin at 7:30 (Gradski bazeni)",
									"<br/>→ Departure from Čakovec at 8:00 (Gradski bazeni)",
									"<br>→ Return ride at 21:00h</p>",
									"<p>You just need your ticket and you’re good to go.</p>"
								]
							}
						],
					},
				],
			},
			tickets: [
				{
					ident: "student",
					icon: "student",
					title: {
						hr: "Student",
						en: "Student",
					},
					// description: {
					// 	hr: "",
					// 	en: [
					// 		"<p>This ticket gives you access to all conference sessions, three meals, after party, and the entry to <a href='https://vidikovac.eu/?lang=en' target='_blank'>Lookout Mađerkin Breg</a> Štrigova (with valid Weblica ticket).</p>",
					// 	]
					// },
					remarks: [
						// TODO (LOW) - implement this
						{
							content: {
								// required
								hr: "",
								en: "",
							},
							icon: "", // SVGS icons - not required
							from: null, // not required
							to: null, // not required
						},
					],
					price: 24,
					listed: true,
					available: true,
					startDate: "2024-10-01",
					endDate: "2025-05-09 23:59:59",
					access: {
						conference: true,
						workshops: true,
						snacks: true,
						three_meals: true,
						after: true,
						extra_madjerka: true,
					},
				},
				{
					ident: "early",
					icon: "clock",
					title: {
						hr: "Early",
						en: "Early",
					},
					// description: {
					// 	hr: "",
					// 	en: [
					// 		"<p>This ticket gives you access to all conference sessions, three meals, after party, and the entry to <a href='https://vidikovac.eu/?lang=en' target='_blank'>Lookout Mađerkin Breg</a> Štrigova (with valid Weblica ticket).</p>",
					// 	]
					// },
					price: 60,
					listed: false,
					available: true,
					startDate: "2024-10-01",
					endDate: "2024-12-31 23:59:59",
					access: {
						conference: true,
						workshops: true,
						snacks: true,
						three_meals: true,
						after: true,
						extra_madjerka: true,
					},
				},
				{
					ident: "regular",
					icon: "standard",
					title: {
						hr: "Regular",
						en: "Regular",
					},
					// description: {
					// 	hr: "",
					// 	en: [
					// 		"<p>This ticket gives you access to all conference sessions, three meals, after party, and the entry to <a href='https://vidikovac.eu/?lang=en' target='_blank'>Lookout Mađerkin Breg</a> Štrigova (with valid Weblica ticket).</p>",
					// 	]
					// },
					price: 120,
					listed: true,
					available: true,
					startDate: "2025-01-01",
					endDate: "2025-05-09 23:59:59",
					access: {
						workshops: true,
						conference: true,
						snacks: true,
						three_meals: true,
						after: true,
						extra_madjerka: true,
					},
				},
			],
			testimonials: [
				{
					speaker: true,
					name: "Frank",
					description: {
						hr: "",
						en: "Data Architect",
					},
					text: {
						hr: [],
						en: [
							'<p>The tangible "startup energy", crowd enthusiasm, and passion for engagement with all the participants was a real boost for me. While a lot of the content was in Croatian, everyone I talked to in groups and in person made an effort to communicate in English (and a bit of German!). The food, weather and setting were also wonderful!! I look forward to following your growth and returning again next year!</p>',
						],
					},
				},
				{
					name: "Ivan",
					description: {
						hr: "developer",
						en: "Developer",
					},
					text: {
						hr: [
							"<p>Na Weblici sam naučio puno novih i korisnih stvari koje koristim svakoga dana, a osim predavanja - ekipa i hrana su super. </p>",
						],
						en: [
							"<p>At Weblica, I learned many new and useful things that I use every day, and besides the lectures - the team and the food are great.</p>",
						],
					},
				},
				{
					speaker: true,
					name: "Marko",
					description: {
						hr: "developer",
						en: "Developer",
					},
					text: {
						hr: [
							"<p>Weblica je sinonim za vrhunske predavače,najnovije trendove u IT-u, pregršt zabave i druženje s kolegama. Zato obavezno stavite Weblicu u vaš kalendar i vidimo se u svibnju u Čakovcu.</p>",
						],
						en: [
							"<p>Weblica is synonymous with top-notch speakers, the latest trends in IT, loads of fun, and networking with colleagues. That's why you should definitely put Weblica in your calendar and see you in May in Čakovec.</p>",
						],
					},
				},
				{
					speaker: true,
					name: "Tomislav",
					description: {
						hr: "Dizajner",
						en: "Designer",
					},
					text: {
						hr: [
							"<p>Weblica je jedno predivno iskustvo jer su prisutni ljudi poput vas, ljudi koji rade isti posao i koji su uspjeli u karijeri koju svi dijelimo. Može se jako puno naučiti iiz predavanja, ali i direktne komunikacije s predavačima jer to nisu neki tamo eterični ljudi iz cijelog svijeta - to su ljudi iz naše okoline koji znaju svoj posao. Mislim da je Weblica super prilika za naučiti nešto novo i napredovati u svojoj karijeri.</p>",
							"<p>Ekipa koja organizira Weblicu, koja stoji iza nje, je zakon. Atmosfera je fantastična i vidi se da ljudi rade sa strašću. Preporučam konferenciju svakome, neće faliti ni dobre zabave, ni hrane, a ni pića.</p>",
						],
						en: [
							"<p>Weblica is one marvelous experience because it is attended by people like you, people who do the same job and who have succeeded in the career we all share. There's so much to learn not only from the lectures but also from direct communication with the speakers because they aren't just some ethereal people from around the world - they are people from our environment who know their job. I think Weblica is a great opportunity to learn something new and advance in your career.</p>",
							"<p>The team organizing Weblica, who stands behind it, is awesome. The atmosphere is fantastic and you can see that people work with passion. I recommend the conference to everyone, there will be no shortage of good fun, food, or drinks.</p>",
						],
					},
				},
				{
					name: "Kristina",
					description: {
						hr: "developer",
						en: "Developer",
					},
					text: {
						hr: [],
						en: [
							"<p>Weblica 2024 was a very interesting experience. The sessions I joined were really informative. I confirmed some things I already knew and learned a lot of new ideas. Honestly, the food was way better than I expected. Good variety, and I didn’t go hungry.</p>",
						],
					},
				},
				{
					name: "Davor",
					description: {
						hr: "Developer",
						en: "Developer",
					},
					text: {
						hr: [
							"<p>Na Weblicu dolazim od njenog drugog izdanja, i od tad sam stalni član i posjetitelj ovog eventa. Po mojem, ovo je najbolji event u ovoj regiji, što se tiče programske i dizajnerske industrije. Vidimo se na druženju uz pive i ostalo.</p>",
						],
						en: [
							"<p>I have been coming to Weblica since its second edition. In my opinion, this is the best event in this region regarding the programming and design industry. Hope to see you at the gathering with beers and the rest.</p>",
						],
					},
				},
				{
					name: "Viktor",
					description: {
						hr: "Developer",
						en: "Developer",
					},
					text: {
						hr: [
							"<p>Na Weblicu se vraćam svake godine. Sviđa mi se networking, druženje s ljudima, super je ekipa i super su predavanja. Bilo bi mi drago da ima više tema vezanih uz Java programiranje.</p>",
						],
						en: [
							"<p>I come to Weblica every year. I like networking and socializing with people, the team is great and so are the lectures. I would be glad if there were more topics related to Java programming.</p>",
						],
					},
				},
				{
					name: "Nikola",
					description: {
						hr: "Developer",
						en: "Developer",
					},
					text: {
						hr: [],
						en: [
							"<p>I've attended Weblica since 2019, and the 2024 one was the best so far. The venue was good, and having two parallel tracks made it easy to pick sessions that suited me. Some sessions could have gone a bit deeper into the subject, but overall, it was definitely worth the visit. And, of course, catching up with fellas from the industry made it all the more special and memorable.</p>",
						],
					},
				},
			],
			extraContent: [
				{
					ident: "blackFriday2024", // translation fil
					location: "tickets-above-buy-button",
					from: "2024-11-28 00:00:00",
					to: "2024-12-07 23:59:59",
				},
				{
					ident: "accessInfo", // translation file
					location: "tickets-above-boxes",
					from: null,
					to: null,
				},
				{
					ident: "workshopsRegister", // translation file
					location: "tickets-above-boxes",
					from: null,
					to: "2024-12-08 23:59:59",
				}
			],
		},
		hacklica: {
			config: {
				// override config.js setup - disable this event for year 2025
				enabled: false,
				active: false,
				visible: false,
				visibleInHeader: false,
			},
			startDateTime: null, // "2025-05-03 08:00:00",
			endDateTime: null, // "2025-05-04 08:00:00",
			specialDates: {
				demos: null,
				winningCeremony: null,
			},
			prizeAmounts: [5000, 3000, 1500],
			menuItems: {
				about: {
					menu: "About",
					url: "/hacklica#about",
					visible: false,
				},
				news: {
					menu: "News",
					url: "/hacklica#news",
					visible: false,
				},
				topics: {
					menu: "Topics",
					url: "/hacklica#topics",
					visible: false,
				},
				venue: {
					menu: "Venue",
					url: "/hacklica#venue",
					visible: false,
				},
				faq: {
					menu: "FAQ",
					url: "/hacklica#faq",
					visible: false,
				},
				sponsors: {
					menu: "Sponsors",
					url: "/hacklica#sponsors",
					visible: false,
				},
				terms: {
					menu: "Terms",
					url: "/hacklica/terms",
					special: true,
					visible: false,
				},
				policy: {
					menu: "Policy",
					url: "/hacklica/policy",
					special: true,
					visible: false,
				},
			},
			buttons: {
				register: {
					title: "Register your team",
					url: "/hacklica/register",
					hollow: true,
					dateLimit: "teamRegistration",
					visible: false,
				},
			},
			forcedButtons: {
				sponsor: {
					title: "Become a Sponsor",
					url: "/sponsors",
					hollow: true,
					external: false,
					visible: false,
					dateLimit: "sponsorRegistration",
				},
			},
			sections: {
				hero: {
					visible: true,
					// introImage: {
					// 	file: "hacklica-2019-2.jpg",
					// 	alt: "Hacklica 2019",
					// },
					introVideo: [
						{
							media: "(max-width: 640px)",
							url: "/media/WEBLICA_banner_animation_640x360.mp4",
							poster: "/media/WEBLICA_banner_1280x720.png",
							type: "video/mp4",
						},
						{
							media: "(max-width: 1280px)",
							url: "/media/WEBLICA_banner_animation_1280x720.mp4",
							poster: "/media/WEBLICA_banner_1280x720.png",
							type: "video/mp4",
						},
						{
							media: "(min-width: 1281px)",
							url: "/media/WEBLICA_banner_animation_1920x1080.mp4",
							poster: "/media/WEBLICA_banner_1920x1080.png",
							type: "video/mp4",
						},
					],
					blocks: [],
				},
				about: {
					visible: true,
					blocks: [
						{
							width: "half", // full || half
							image: {
								file: "hacklica-2019-3.jpg",
								alt: "Hacklica 2019",
							},
						},
						{
							width: "half",
							text: "txt_aaa",
						},
					],
				},
				news: {
					visible: false,
				},
				topics: {
					visible: true,
				},
				venue: {
					visible: true,
				},
				faq: {
					visible: true,
				},
				sponsors: {
					visible: true,
				},
				newsletter: {
					visible: true,
				},
				testimonials: {
					visible: false,
				},
				historyGallery: {
					visible: true,
				},
			},
			__venue: {
				name: {
					hr: "Graditeljska škola",
					en: "School of Architecture",
				},
				nameAlt: {
					hr: "Dvorana Graditeljske škole",
					en: "Hall of the School of Architecture",
				},
				street: "Športska ulica 1",
				postalCode: "40000",
				city: "Čakovec",
				country: "Croatia",
				countryShort: "HR",
				leaflet: {
					location: [46.38921, 16.42269],
					zoom: 19,
				},
				mapUrl:
					"https://www.google.com/maps/place/Graditeljska+%C5%A1kola+%C4%8Cakovec/@46.3888122,16.4220393,15z/data=!4m5!3m4!1s0x0:0x129b433371a3c66f!8m2!3d46.3888122!4d16.4220399",
				mapImage: "gsc-dvorana-map.png",
				images: ["gsc-dvorana-1.jpeg", "gsc-dvorana-2.jpeg"],
			},
			__faq: {
				hr: [
					{
						title: "HR-HH-faq 1",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 2",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 3",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 4",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 5",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 6",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 7",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 8",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
				],
				en: [
					{
						title: "EN-What is the smallest or the largest team size?",
						short:
							"Minimum is 2 members (as you probably expected) and the largest team can have up to 6 members. Everything in between is fine by us.",
						full: "Minimum is 2 members (as you probably expected) and the largest team can have up to 6 members. Everything in between is fine by us.",
					},
					{
						title: "Can we base our work on preexisting work of ours?",
						short: "Short answer would be-no! But ...",
						full: "If your team has some utilities or smaller libraries that can aid you, yes, you can use that. But beware! We will check the code (it is part of judging process) and we will disqualify full teams if we notice that code volume is not consistent with what is possible in 24 hour window. You will be able to speak up of course if such event occurs, but we are all seniors here and can not be fooled so easily!",
					},
					{
						title: "faq 3",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 4",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
				],
			},
			__news: {
				hr: [
					{
						title: "HR-HH-here we go again",
						when: "2021-09-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "HH-here we go again #2",
						when: "2021-09-03 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "",
					},
					{
						title: "HH-full steam ahead",
						when: "2021-11-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "HH-tickets are ready-go go go",
						when: "2024-01-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
				],
				en: [
					{
						title: "EN-HH-here we go again",
						when: "2021-09-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "HH-here we go again #2",
						when: "2021-09-03 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "",
					},
					{
						title: "HH-full steam ahead",
						when: "2021-11-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "HH-tickets are ready-go go go",
						when: "2024-01-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
				],
			},
			__topics: {
				hr: [
					{
						title: "HR topic 1",
						short:
							"HR Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "HR topic 2",
						short:
							"HR Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "HR topic 3",
						short:
							"HR Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
				],
				en: [
					{
						title: "EN topic 1",
						short:
							"EN Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "EN topic 2",
						short:
							"EN Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "EN topic 3",
						short:
							"EN Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
				],
			},
		},
		worklica: {
			__days: [
				{
					startDateTime: "2025-05-09 08:00:00",
					endDateTime: "2025-05-09 23:59:59"
				},
				{
					startDateTime: "2025-06-13 08:00:00",
					endDateTime: "2025-06-13 23:59:59"
				},
			],
			// previewMode: ["schedule"],
			// workInProgress: ["speakers", "schedule"],
			tracks: ["track1"],
			externalLinks: EXTERNAL_LINKS,
			startDateTime: "2025-05-09 10:10:00",
			endDateTime: "2025-05-09 23:59:59",
			options: {
				entrioEventID: "20699",
				// showSpeakerRegisterButton: true,
				enableWorkshopRegistration: true
			},
			menuItems: {
				about: {
					menu: "About",
					url: "/worklica#about",
					visible: false,
				},
				news: {
					menu: "News",
					url: "/worklica#news",
					visible: false,
				},
				speakers: {
					menu: "Speakers",
					url: "/worklica#speakers",
					visible: true,
				},
				schedule: {
					menu: "Schedule",
					url: "/worklica#schedule",
					visible: true,
				},
				tickets: {
					menu: "Tickets",
					url: "/worklica#tickets",
					visible: false,
				},
				venue: {
					menu: "Venue",
					url: "/worklica#venue",
					visible: "active,before",
				},
				faq: {
					menu: "FAQ",
					url: "/worklica#faq",
					visible: "active,before",
				},
				sponsors: {
					menu: "Sponsors",
					url: "/worklica#sponsors",
					visible: true,
				},
			},
			buttons: {
				tickets: {
					title: "Get Tickets",
					url: "/worklica#tickets",
					hollow: false,
					external: false,
					visible: true,
					dateLimit: "ticketSales.worklica",
					//---
					visibleOnHero: true,
					hollowOnHero: true,
					extraClassesOnHero: ["showOnSmall"],
					// ---
					floatingSpecial: {
						// if defined, it will override given when on floating menu - this jumps directly to Entrio instead of to #tickets section
						url: EXTERNAL_LINKS.tickets,
						external: true,
					},
				},
				register: {
					title: "Register a workshop",
					url: EXTERNAL_LINKS.sessions,
					hollow: true,
					external: true,
					visible: false,
					visibleOnHero: true,
					dateLimit: "workshopRegistration",
				},
			},
			forcedButtons: {
				sponsor: {
					title: "Become a Sponsor",
					url: "/sponsors",
					hollow: true,
					external: false,
					visible: true,
					linkInFooter: true,
					dateLimit: "sponsorRegistration",
				},
			},
			sections: {
				hero: {
					visible: true,
					// introImage: {
					// 	file: "worklica-2019-1.jpg",
					// 	alt: "Worklica 2019",
					// },
					introVideo: [
						{
							media: "(max-width: 640px)",
							url: "/media/WEBLICA_banner_animation_640x360.mp4",
							poster: "/media/WEBLICA_banner_1280x720.png",
							type: "video/mp4",
						},
						{
							media: "(max-width: 1280px)",
							url: "/media/WEBLICA_banner_animation_1280x720.mp4",
							poster: "/media/WEBLICA_banner_1280x720.png",
							type: "video/mp4",
						},
						{
							media: "(min-width: 1281px)",
							url: "/media/WEBLICA_banner_animation_1920x1080.mp4",
							poster: "/media/WEBLICA_banner_1920x1080.png",
							type: "video/mp4",
						},
					],
					blocks: [],
				},
				about: {
					visible: true,
					blocks: [
						{
							width: "half", // full || half
							image: {
								file: "worklica-2019-4.jpg",
								alt: "Worklica 2019",
							},
						},
						{
							width: "half",
							text: "txt_aaa",
						},
						{
							width: "half",
							text: "txt_bbb",
						},
						{
							width: "half", // full || half
							image: {
								file: "worklica-2019-2.jpg",
								alt: "Worklica 2019",
							},
						},
					],
				},
				news: {
					visible: false,
				},
				speakers: {
					visible: true,
				},
				schedule: {
					visible: true,
				},
				venue: {
					visible: "before,active",
				},
				tickets: {
					visible: "before,active",
				},
				faq: {
					visible: "before,active",
				},
				sponsors: {
					visible: true,
				},
				newsletter: {
					visible: true,
				},
				testimonials: {
					visible: false,
				},
				historyGallery: {
					visible: true,
				},
			},
			venue: {
				venue: "dks",
			},
			tickets: [
				{
					ident: "student",
					icon: "student",
					title: {
						hr: "Student",
						en: "Student",
					},
					// description: {
					// 	hr: "",
					// 	en: [
					// 		"<p>This ticket gives you access to all conference sessions, three meals, after party, and the entry to <a href='https://vidikovac.eu/?lang=en' target='_blank'>Lookout Mađerkin Breg</a> Štrigova (with valid Weblica ticket).</p>",
					// 	]
					// },
					remarks: [
						// TODO (LOW) - implement this
						{
							content: {
								// required
								hr: "",
								en: "",
							},
							icon: "", // SVGS icons - not required
							from: null, // not required
							to: null, // not required
						},
					],
					price: 24,
					listed: true,
					available: true,
					startDate: "2024-10-01",
					endDate: "2025-05-09 23:59:59",
					access: {
						conference: true,
						workshops: true,
						snacks: true,
						three_meals: true,
						after: true,
						extra_madjerka: true,
					},
				},
				{
					ident: "regular",
					icon: "standard",
					title: {
						hr: "Regular",
						en: "Regular",
					},
					// description: {
					// 	hr: "",
					// 	en: [
					// 		"<p>This ticket gives you access to all conference sessions, three meals, after party, and the entry to <a href='https://vidikovac.eu/?lang=en' target='_blank'>Lookout Mađerkin Breg</a> Štrigova (with valid Weblica ticket).</p>",
					// 	]
					// },
					price: 120,
					listed: true,
					available: true,
					startDate: "2025-01-01",
					endDate: "2025-05-09 23:59:59",
					access: {
						conference: true,
						workshops: true,
						snacks: true,
						three_meals: true,
						after: true,
						extra_madjerka: true,
					},
				},
			],
			speakers: {
				"culjak-ivan": {
					visible: true,
					placeholder: false,
					image: "culjak-ivan.jpg",
					name: "Ivan",
					surname: "Čuljak",
					contact: {
						email: "ivan@culjak.xyz",
					},
					position: {
						hr: "Cloud Whisperer @ Cloudlet Ltd",
						en: "Cloud Whisperer @ Cloudlet Ltd",
					},
					bio: {
						hr: "A developer evolved into an architect. Loved salvaging wrecks, now enjoys correcting the course well before the wreck happens. Keeps postponing releasing his SaaS and podcast.",
						en: "A developer evolved into an architect. Loved salvaging wrecks, now enjoys correcting the course well before the wreck happens. Keeps postponing releasing his SaaS and podcast.",
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/ivandothr/",
					},
					// pixels: [
					// 	"p2trh",
					// 	"p1bl"
					// ]
				},
				"breznjak-nikola": {
					visible: true,
					placeholder: false,
					image: "breznjak-nikola.jpeg",
					name: "Nikola",
					surname: "Brežnjak",
					contact: {
						email: "nikola.breznjak@gmail.com",
					},
					position: {
						hr: "",
						en: "VP of Engineering @ Nomorobo",
					},
					bio: {
						hr: "",
						en: [
							"Engineering executive leading people and developing software products with a focus on tech innovation.",
							"Skilled in strategic leadership, empowering globally distributed teams, and guiding companies to success.",
							"Committed to community engagement, with contributions to education and open-source projects.",
							"Demonstrated passion and relentless pursuit of excellence by transitioning from software engineering to executive leadership at a Fortune 500."
						]
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/nikola-bre%C5%BEnjak-892b9a24",
					},
					// pixels: [
					// 	"p2tlv",
					// 	"p1br"
					// ]
				},
				// "simic-bruno": {
				// 	// NOT USED
				// 	visible: false,
				// 	placeholder: false,
				// 	image: "simic-bruno.png",
				// 	name: "Bruno",
				// 	surname: "Šimić",
				// 	contact: {
				// 		email: "bruno@simicmail.com",
				// 		phone: "+385953536050",
				// 	},
				// 	position: {
				// 		hr: "",
				// 		en: "", // missing info
				// 	},
				// 	bio: {
				// 		hr: "",
				// 		en: "", // missing info
				// 	},
				// 	social: {
				// 		linkedIn: "https://www.linkedin.com/in/brunosimic",
				// 	},
				// },
				"duranovic-dino": {
					visible: true,
					placeholder: false,
					image: "duranovic-dino.png",
					name: "Dino",
					surname: "Duranović",
					contact: {
						email: "dino.duranovic@ebcont.com",
						phone: "+43664809691076",
					},
					position: {
						hr: "",
						en: "Senior IT Consultant @ EBCONT",
					},
					bio: {
						hr: null,
						en: "Specializing in the development and consulting of full-stack applications and AI-powered solutions"
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/dino-duranovic-802b15245/",
					},
				},
				"javor-ante": {
					visible: true,
					placeholder: false,
					image: "javor-ante.jpeg",
					name: "Ante",
					surname: "Javor",
					contact: {
						email: "ante.javor@memgraph.io",
						phone: "",
					},
					position: {
						hr: "",
						en: "Developer Experience Engineer @ Memgraph",
					},
					bio: {
						hr: null,
						en: "He focuses on improving the experience for all developers using Memgraph. He is passionate about database systems, algorithms, and data structures and enjoys engaging with other developers. In addition to his work at Memgraph, Ante is also a guest lecturer at the University of Applied Sciences in Bjelovar, helping students grasp the fundamentals of algorithms and data structures. To balance his sedentary work life, he spends his free time outdoors—running or playing padel."
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/antejavor",
					},
				},
				"voska-filip": {
					visible: true,
					placeholder: false,
					image: "voska-filip-2025.jpg",
					name: "Filip",
					surname: "Voska",
					contact: {
						email: "filip.voska@gmail.com",
					},
					position: {
						hr: "Filip is JavaScript engineer from Infinum who spends his days practicing Dark Angular Magic",
						en: "Filip is JavaScript engineer from Infinum who spends his days practicing Dark Angular Magic",
					},
					bio: {
						hr: "Filip graduated from Faculty of Electrical Engineering and Computing, University of Zagreb in 2017 and has started his careers at Infinum as JavaScript Engineer.\r\n\r\nOver the years, FIlip gathered knowledge of various Frontend topics, with focus on Angular, and became Angular Lead Engineer.\r\n\r\nSome more time passed and Filip started focusing more on soft-skills and became JavaScript Team Lead at Infinum, while still continuing to do Angular development and being involved in architecture-level decision-making.\r\n\r\nAs for FIlip's personal interests and hobbies, he likes PC/Nintendo Switch Gaming, messing around with HiFi gear and mehcnical keyboards, and being a loving husband & father to his wife & child.",
						en: "Filip graduated from Faculty of Electrical Engineering and Computing, University of Zagreb in 2017 and has started his careers at Infinum as JavaScript Engineer.\r\n\r\nOver the years, FIlip gathered knowledge of various Frontend topics, with focus on Angular, and became Angular Lead Engineer.\r\n\r\nSome more time passed and Filip started focusing more on soft-skills and became JavaScript Team Lead at Infinum, while still continuing to do Angular development and being involved in architecture-level decision-making.\r\n\r\nAs for FIlip's personal interests and hobbies, he likes PC/Nintendo Switch Gaming, messing around with HiFi gear and mehcnical keyboards, and being a loving husband & father to his wife & child.",
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/filip-voska-682170b0",
					},
				},
			},
			sessions: [
				{
					// required: true, // DEBUG - test only
					visible: true,
					placeholder: false,
					ident: "the-angular-renaissance-1",
					identGroup: "the-angular-renaissance",
					duration: 45,
					type: "workshop",
					language: "en",
					level: "intermediate",
					code: "heavy",
					title: {
						hr: "The Angular Renaissance",
						en: "The Angular Renaissance",
					},
					titleSuffix: {
						hr: "1/2",
						en: "1/2"
					},
					titleGroup: {
						hr: "The Angular Renaissance",
						en: "The Angular Renaissance",
					},
					description: {
						hr: "",
						en: `
						<p>During this workshop, we will build a simple todo-list application using some of the latest Angular features:</p>
						<p>
							<ul>
								<li><a href="https://angular.dev/guide/signals" target="_blank">Signals</a></li>
								<li><a href="https://angular.dev/guide/signals/resource" target="_blank">Resources</a></li>
								<li><a href="https://angular.dev/guide/templates/control-flow" target="_blank">Control flow</a></li>
								<li><a href="https://angular.dev/guide/forms/reactive-forms" target="_blank">Reactive</a> & <a href="https://angular.dev/guide/forms/typed-forms" target="_blank">Typed Forms</a></li>
								<li><a href="https://v17.angular.io/guide/standalone-components" target="_blank">Standalone Components</a></li>
								<li><a href="https://ngrx.io/guide/signals/signal-store" target="_blank">NgRx SignalStore</a> + <a href="https://ngrx.io/guide/signals/signal-store/entity-management" target="_blank">Entity Management</a></li>
							</ul>
						</p>
						<p>As you will see, modern Angular development can be very elegant and we will break down some preconceived notions that might exists about Angular being too verbose or cumbersome to work with.</p>
						`
					},
					speakers: ["voska-filip"],
				},
				{
					visible: true,
					placeholder: false,
					skipOnSurvey: true,
					skipOnHistory: true,
					ident: "the-angular-renaissance-2",
					identGroup: "the-angular-renaissance",
					duration: 30,
					type: "workshop",
					language: "en",
					level: "intermediate",
					code: "heavy",
					doNotEvaluate: true,
					title: {
						hr: "The Angular Renaissance",
						en: "The Angular Renaissance",
					},
					titleSuffix: {
						hr: "2/2",
						en: "2/2"
					},
					titleGroup: {
						hr: "The Angular Renaissance",
						en: "The Angular Renaissance",
					},
					description: {
						hr: "",
						en: `
						<p>During this workshop, we will build a simple todo-list application using some of the latest Angular features:</p>
						<p>
							<ul>
								<li><a href="https://angular.dev/guide/signals" target="_blank">Signals</a></li>
								<li><a href="https://angular.dev/guide/signals/resource" target="_blank">Resources</a></li>
								<li><a href="https://angular.dev/guide/templates/control-flow" target="_blank">Control flow</a></li>
								<li><a href="https://angular.dev/guide/forms/reactive-forms" target="_blank">Reactive</a> & <a href="https://angular.dev/guide/forms/typed-forms" target="_blank">Typed Forms</a></li>
								<li><a href="https://v17.angular.io/guide/standalone-components" target="_blank">Standalone Components</a></li>
								<li><a href="https://ngrx.io/guide/signals/signal-store" target="_blank">NgRx SignalStore</a> + <a href="https://ngrx.io/guide/signals/signal-store/entity-management" target="_blank">Entity Management</a></li>
							</ul>
						</p>
						<p>As you will see, modern Angular development can be very elegant and we will break down some preconceived notions that might exists about Angular being too verbose or cumbersome to work with.</p>
						`
					},
					speakers: ["voska-filip"],
				},
				{
					visible: true,
					placeholder: false,
					ident: "from-pixels-to-knowledge-1",
					identGroup: "from-pixels-to-knowledge",
					duration: 45,
					type: "workshop",
					language: "en",
					level: "intermediate",
					code: "heavy",
					title: {
						hr: "From Pixels to Knowledge",
						en: "From Pixels to Knowledge",
					},
					titleSuffix: {
						hr: "1/2",
						en: "1/2"
					},
					titleGroup: {
						hr: "From Pixels to Knowledge",
						en: "From Pixels to Knowledge",
					},
					description: {
						hr: '',
						en: [
							"<p>Dive into the intersection of computer vision, knowledge graphs, and advanced graph analytics. In this joint EBCONT and Memgraph workshop, you'll learn how to classify, compare and transform images into text descriptions using neural networks. We will also convert that text into a structured knowledge graph. With the graph built, we'll dive into GraphRAG to enable natural language querying — extracting semantic insights from the images through the graph. By the end, you'll have a working pipeline that turns raw images into actionable knowledge.</p>",
							"<ul class='description'>",
							"<div class='caption'>To start with our hands-on workshop, you will need some preconditions:</div>",
							"<li>your laptop (desktop with monitor may eventually work too ;-) )</li>",
							"<li>docker and docker compose up and running</li>",
							"<li>specific docker images downloaded, i.e. Memgraph</li>",
							"</ul>"
						],
					},
					speakers: ["duranovic-dino", "javor-ante"],
				},
				{
					visible: true,
					placeholder: false,
					skipOnSurvey: true,
					skipOnHistory: true,
					ident: "from-pixels-to-knowledge-2",
					identGroup: "from-pixels-to-knowledge",
					duration: 45,
					type: "workshop",
					language: "en",
					level: "intermediate",
					code: "heavy",
					doNotEvaluate: true,
					title: {
						hr: "From Pixels to Knowledge",
						en: "From Pixels to Knowledge",
					},
					titleSuffix: {
						hr: "2/2",
						en: "2/2"
					},
					titleGroup: {
						hr: "EFrom Pixels to Knowledge",
						en: "From Pixels to Knowledge",
					},
					description: {
						hr: '',
						en: [
							"<p>Dive into the intersection of computer vision, knowledge graphs, and advanced graph analytics. In this joint EBCONT and Memgraph workshop, you'll learn how to classify, compare and transform images into text descriptions using neural networks. We will also convert that text into a structured knowledge graph. With the graph built, we'll dive into GraphRAG to enable natural language querying — extracting semantic insights from the images through the graph. By the end, you'll have a working pipeline that turns raw images into actionable knowledge.</p>",
							"<ul class='description'>",
							"<div class='caption'>To start with our hands-on workshop, you will need some preconditions:</div>",
							"<li>your laptop (desktop with monitor may eventually work too ;-) )</li>",
							"<li>docker and docker compose up and running</li>",
							"<li>specific docker images downloaded, i.e. Memgraph</li>",
							"</ul>"
						],
					},
					speakers: ["duranovic-dino", "javor-ante"],
				},
				{
					visible: true,
					placeholder: false,
					ident: "cloudkiss-1",
					identGroup: "cloudkiss",
					duration: 45,
					type: "workshop",
					language: "en",
					level: "intermediate",
					code: "none",
					title: {
						hr: "CloudKISS",
						en: "CloudKISS",
					},
					titleSuffix: {
						hr: "1/2",
						en: "1/2"
					},
					titleGroup: {
						hr: "CloudKISS",
						en: "CloudKISS",
					},
					description: {
						hr: '',
						en: 'Over-engineering stuff is not only tempting, but also easier, especially in the cloud.\r\nNo matter how grandiose and sluggish solution you build the cloud can run it and make it performant enough - until you run out of other people\'s money.\r\n\r\nDesigning a simple, resilient, and performant solution takes discipline, and takes away the fun... the "fun" of being on a rollercoaster. That\'s where I come in as a "rollercoaster survivor" to tell you that after a while the "fun" stops and it becomes a never-ending nightmare.\r\n\r\nI\'ll take you on a CloudKISS journey during which you\'ll hear how to build simple and stupid cloud solutions, when to consider adding another layer of complexity, what should be prioritized and - how to incorporate contentment into your solutions.\r\n\r\nWe’ll talk about why we are doing things, we’ll talk about processes, we’ll talk about steps, we’ll define who does what at which stage, and how to adapt all of these to your specific needs.\r\n\r\nWe’ll wrap it up with a cloud solution architecture which has a tendency of being good enough for most projects, but you’ll also learn which parts can you adapt and how, all based on the previous steps.',
					},
					speakers: ["culjak-ivan"],
				},
				{
					visible: true,
					placeholder: false,
					skipOnSurvey: true,
					skipOnHistory: true,
					ident: "cloudkiss-2",
					identGroup: "cloudkiss",
					duration: 45,
					type: "workshop",
					language: "en",
					level: "intermediate",
					code: "none",
					doNotEvaluate: true,
					title: {
						hr: "CloudKISS",
						en: "CloudKISS",
					},
					titleSuffix: {
						hr: "2/2",
						en: "2/2"
					},
					titleGroup: {
						hr: "CloudKISS",
						en: "CloudKISS",
					},
					description: {
						hr: '',
						en: 'Over-engineering stuff is not only tempting, but also easier, especially in the cloud.\r\nNo matter how grandiose and sluggish solution you build the cloud can run it and make it performant enough - until you run out of other people\'s money.\r\n\r\nDesigning a simple, resilient, and performant solution takes discipline, and takes away the fun... the "fun" of being on a rollercoaster. That\'s where I come in as a "rollercoaster survivor" to tell you that after a while the "fun" stops and it becomes a never-ending nightmare.\r\n\r\nI\'ll take you on a CloudKISS journey during which you\'ll hear how to build simple and stupid cloud solutions, when to consider adding another layer of complexity, what should be prioritized and - how to incorporate contentment into your solutions.\r\n\r\nWe’ll talk about why we are doing things, we’ll talk about processes, we’ll talk about steps, we’ll define who does what at which stage, and how to adapt all of these to your specific needs.\r\n\r\nWe’ll wrap it up with a cloud solution architecture which has a tendency of being good enough for most projects, but you’ll also learn which parts can you adapt and how, all based on the previous steps.',
					},
					speakers: ["culjak-ivan"],
				},
				{
					visible: true,
					ident: "vibe-programming",
					// identGroup: "vibe-programming",
					duration: 45,
					type: "workshop",
					language: "en",
					level: "intermediate",
					code: "heavy",
					title: {
						hr: "Vibe Programming: The End of Coding as We Know It",
						en: "Vibe Programming: The End of Coding as We Know It",
					},
					// titleGroup: {
					// 	hr: "Vibe Programming: The End of Coding as We Know It",
					// 	en: "Vibe Programming: The End of Coding as We Know It",
					// },
					description: {
						hr: "",
						en: [
							"<p>Have you ever imagined building a complete, functional software application without typing a single line of code? Meet “Vibe Programming”—a paradigm where prompting AI tools and orchestrating intelligent agents takes the place of manual coding. In this session, we’ll explore how natural-language prompts, combined with powerful AI systems, can generate, refactor, and deploy application logic on the fly.</p>",
							"<p>Attendees will see a live demo of creating a non-trivial app—complete with backend logic and user-facing features—using nothing more than carefully guided AI prompts and a “vibe”-driven workflow. We’ll walk through real-world applications, highlight pitfalls and best practices, and discuss how these new approaches might disrupt conventional software development.</p>",
							"<p>By the end of this workshop, you’ll not only understand the fundamentals of vibe programming and AI-driven design, but also gain insights on how to apply these techniques in your own projects, cutting development time dramatically—and maybe even having fun in the process.</p>"
						]
					},
					speakers: ["breznjak-nikola"]
				},
			],
			sessionAssets: [
				{
					visible: true,
					ident: "the-angular-renaissance",
					remark: {
						hr: "",
						en: [
							"<p>In order to get everyone ready to code quickly on their own machines, we provide a starter repository. It is expected that you come prepared to the workshop by cloning the repository and following setup instructions from the README.</p>",
						]
					},
					items: [
						{
							title: "ng-renaissance-workshop",
							github: "https://github.com/fvoska/ng-renaissance-workshop"
						},
					]
				},
				{
					visible: true,
					ident: "from-pixels-to-knowledge",
					remark: {
						hr: "",
						en: "Please check our workshop public GitHub project directory - everything that you will need fot it will be published here:"
					},
					items: [
						{
							title: "Weblica-Workshop-GraphRAG",
							github: "https://github.com/revaddu/Weblica-Workshop-GraphRAG"
						}
					]
				},
				// {
				// 	// DEV
				// 	visible: true,
				// 	ident: "cloudkiss", // matched single session identGroup/ident
				// 	// idents: [ // matches any of given session identGroup/ident
				// 	// 	"cloudkiss-1",
				// 	// 	"cloudkiss-2",
				// 	// ],
				// 	remark: {
				// 		hr: "",
				// 		en: "In order to prepare for this workshop, please download these files and follow the instructions within.",
				// 	},
				// 	items: [
				// 		{
				// 			title: {
				// 				hr: "Preparation Guide",
				// 				en: "Preparation Guide",
				// 			},
				// 			file: "dev1111.txt", // web asset
				// 			// ident: "dev1111" // server-side asset ident
				// 		},
				// 		{
				// 			title: {
				// 				hr: "Extras Guide",
				// 				en: "Extras Guide",
				// 			},
				// 			ident: "dev2222", // server-side asset ident
				// 		},
				// 		{
				// 			title: {
				// 				hr: "Online Guide",
				// 				en: "Online Guide",
				// 			},
				// 			url: "https://stackoverflow.com/", // external resource
				// 		},
				// 		{
				// 			title: {
				// 				hr: "Github Repo",
				// 				en: "Github Repo",
				// 			},
				// 			github: "https://stackoverflow.com/", // external resource
				// 		},
				// 	],
				// },
			],
			schedule: [
				{ session: "the-angular-renaissance-1" },
				TRACK_BREAK(),
				{ session: "the-angular-renaissance-2" },
				TRACK_BREAK(),
				{ session: "from-pixels-to-knowledge-1" },
				TRACK_BREAK(),
				{ session: "from-pixels-to-knowledge-2" },
				LUNCH_BREAK(),
				{ session: "cloudkiss-1" },
				TRACK_BREAK(),
				{ session: "cloudkiss-2" },
				TRACK_BREAK(),
				{ session: "vibe-programming" }
			],
			faq: {
				hr: [],
				en: [
					{
						title: "Who is Worklica for?",
						short: "",
						full: "Worklica is designed for developers who want to explore technical challenges and solutions in greater detail. Unlike conference sessions, workshops offer more time to dig deeper into specific topics, sometimes requiring active participation. Each workshop will indicate whether hands-on involvement is expected.",
					},
					{
						title: "Do I need to have technical background to participate?",
						short: "",
						full: "The required knowledge level for each workshop depends on the topic. Some workshops will dive deep into technical subjects, while others may be more accessible to beginners. Each workshop will clearly state the knowledge level required, so you can choose the ones that best fit your experience.",
					},
					{
						title: "Where and when will Worklica {{currentYear}} be held?",
						short: "",
						full: [
							"<p>Worklica {{currentYear}} will be held on <b>{{eventDate}}</b>, starting at {{eventTime}}.<br/>",
							"It will be held at <a href='/{{event}}/{{linkLang}}#venue'><b>{{venueName}}</b></a><b>, {{venueAddress}}</b>.</p>",
							// "It will be held at <a href='{{mapUrl}}' target='_blank'><b>{{venueNameAndAddress}}</b></a>.</p>",
						],
					},
					{
						title: "How to apply for participation as a lecturer and what is the application deadline?",
						short: "",
						full: `Applications for speakers end on {{workshopRegistration.to}} at midnight, and you can register via <a href='{{sessionsUrl}}' target='_blank'>Sessionize platform</a> (please notice Session type entry).`,
					},
					{
						title: "How can I become a Worklica sponsor?",
						short: "",
						full: "If you are interested in sponsorship, please send us an inquiry <a href='{{urlPrefix}}/{{linkLang}}/sponsors'>using this form.</a>",
					},
					{
						title: "Is participation free of charge?",
						short: "",
						full: "Unfortunately not. <a href='{{urlPrefix}}/{{linkLang}}/{{event}}/#tickets'>Check out the tickets</a>",
					},
					{
						title: "Can I get a refund if I can not longer attend?",
						short: "",
						full: "No, we do not provide refunds, but we can authorize ticket transfer.<br/>Please contact us at <a href='mailto:info@weblica.hr' targget='_blank'>info@weblica.hr</a>.",
					},
					{
						title: "Will it be possible to park a car somewhere?",
						short: "",
						full: "Yes, free parking is available.",
					},
					// {
					// 	title: "x",
					// 	short: "",
					// 	full: ""
					// },
				],
			},
			news: {
				hr: [
				],
				en: [
					{
						// title: "Hop on the Weblica bus!",
						when: "2025-05-05",
						startDate: "2025-05-05 00:00:00",
						endDate: "2025-05-09 23:59:59",
						breaking: true,
						fullBlocks: [
							{
								width: "third",
								image: {
									file: "weblica-bus.jpg",
									alt: "weblica-bus"
								}
							},
							{
								width: "twothirds",
								text: [
									"<p>On May 9th, we’re organizing free bus rides for all Weblica 2025 attendees:<p>",
									"<p>→ Departure from Varaždin at 7:30 (Gradski bazeni)",
									"<br/>→ Departure from Čakovec at 8:00 (Gradski bazeni)",
									"<br>→ Return ride at 21:00h</p>",
									"<p>You just need your ticket and you’re good to go.</p>"
								]
							}
						],
					},
				],
			},
			extraContent: [
				{
					ident: "workshopAccess", // translation file
					location: "tickets-above-boxes",
					from: null,
					to: "2024-12-07 23:59:59",
				},
				// {
				// 	ident: "workshopsAccess", // translation file
				// 	location: "tickets-above-boxes",
				// 	from: null,
				// 	to: null
				// },
				// ---
				{
					ident: "ticketRequirement",
					location: "schedule-above-list",
					from: null,
					to: "2024-12-07 23:59:59",
				},
			],
		},
	},
	news: {
		// generic - show on all events - this data comes after event-specific items generating combined data
		hr: [],
		en: [],
	},
	faq: {
		// generic - show on all events - this data comes after event-specific items generating combined data
		hr: [],
		en: [
			// {
			// 	title: "Generic FAQ Entry #1",
			// 	short: "",
			// 	full: "Does this work? If so, this will be visible!",
			// },
		],
	},
	venues: [
		// generic venues - for easy reuse
		{
			ident: "dks",
			name: {
				hr: "Dom Kulture Štrigova",
				en: "Cultural center Štrigova",
			},
			nameAlt: {
				hr: "Dom Kulture Štrigova",
				en: "Cultural center Štrigova",
			},
			// url: "https://opcinastrigova.hr/dom-kulture-strigova/",
			// description: {
			// 	hr: [
			// 		"<p>Centar je kulturnih zbivanja na području Općine Štrigova pa i šire.  Isti je obnovljen i rekonstruiran 2021. godine te je tako ukupna površina proširena na 1 172 kvadratna metra koji koriste udruge civilnog društva te služi i za organizaciju kulturnih i društvenih događanja. Multifunkcionalni ambijent prostora, opremljenost i koncepcija, omogućavaju  održavanje više aktivnosti odjednom pri čemu se svakoj može osigurati određena izoliranost.</p>",
			// 		"<p>Dom se sastoji od prezentacijskog i enogastronomskog prostora, male dvorane za predavanje i prezentacije, prostora za druženje te komforne kuhinje u prizemlju, dok se na prvom katu nalazi suvremeno opremljena dvorana s 224 sjedeća mjesta za razne glazbeno-scenske aktivnosti, kazališne i filmske projekcije, skupove te kongrese.  Za osobe smanjene pokretljivosti osiguran je lift kako bi im se olakšalo kretanje po domu.</p>"
			// 	],
			// 	en: [
			// 		"<p>It is the center of cultural events in the area of ​​Štrigova Municipality and beyond. It was renovated and reconstructed in 2021, and thus the total area was expanded to 1,172 square meters, which is used by civil society associations and is also used for the organization of cultural and social events. The multifunctional ambience of the space, the equipment and the concept, make it possible to hold several activities at the same time, while each can be provided with a certain isolation.</p>",
			// 		"<p>The home consists of a presentation and enogastronomy area, a small hall for lectures and presentations, a space for socializing and a comfortable kitchen on the ground floor, while on the first floor there is a modernly equipped hall with 224 seats for various musical and stage activities, theater and film projections, gatherings and congresses. An elevator is provided for people with reduced mobility to make it easier for them to move around the house.</p>"
			// 	]
			// },
			street: "Štrigova 103",
			postalCode: "40312",
			city: "Štrigova",
			country: "Croatia",
			countryShort: "HR",
			mapImage: "strigova-dom-kulture-map-2.jpg",
			mapUrl:
				"https://www.google.hr/maps/place/%C5%A0trigova+103,+40312,+%C5%A0trigova/@46.5001192,16.2885758,17z/data=!4m6!3m5!1s0x476f4ec49751d3a1:0x84a12a23fd1ca131!8m2!3d46.5001377!4d16.2901422!16s%2Fg%2F11rqx_d1s4?hl=hr&entry=ttu&g_ep=EgoyMDI0MTAwOC4wIKXMDSoASAFQAw%3D%3D",
			images: [
				{
					// title: "Zgrada Doma kulture",
					img: "dom_kulture_strigova-10.jpg",
				},
				{
					// title: "Glavna dvorana",
					img: "dom_kulture_strigova-8.jpg",
				},
				{
					// title: "Zona za partnere i pauze",
					img: "dom_kulture_strigova-2.jpg",
				},
				{
					// title: "Zona za partnere i pauze",
					img: "dom_kulture_strigova-a1.jpg",
				},
				{
					// title: "Chill out zona",
					img: "dom_kulture_strigova-3.jpg",
				},
			],
		},
		{
			ident: "vxy",
			name: {
				hr: "Vinarija XY",
				en: "Vinarija XY",
			},
			nameAlt: {
				hr: "Vinarija XY",
				en: "Vinarija XY",
			},
			street: "Štrigova XY",
			postalCode: "40312",
			city: "Štrigova",
			country: "Croatia",
			countryShort: "HR",
		},
	],
	sponsors: {
		l5: [
			{
				name: "TRIA",
				logo: "tria_primarni_logotip_white and red_bez slogana.png",
				url: "https://tria.hr",
				linkedIn: "https://www.linkedin.com/company/tria-hr",
				tags: [
					"Web Development",
					"JavaScript",
					"Frontend",
					"Backend",
					"System Architecture",
					"Databases",
					"Custom Solutions",
					"DevOps",
				],
				description: {
					hr: [],
					en: [
						"<p>Tria is a software development company focused on building tailored solutions for complex business challenges.</p>",
						"<p>With experience across industries like eCommerce, fintech, health tech, pharma, logistics, and automotive, Tria adapts its skills to meet diverse sector needs.</p>",
						"<p>Their technology stack is centered on JavaScript, utilizing Vue.js, Docker, PostgreSQL, and other advanced technologies to deliver high-performance, custom software solutions.</p>",
						"<p>Tria’s services cover everything from system architecture, software development, and DevOps, to UI/UX design, product development and consulting.</p>",
					],
				},
			},
			{
				name: "Factory X",
				url: "https://factory-x.hr",
				linkedIn: "https://www.linkedin.com/company/factory-x-d-o-o",
				logo: "factory-x-logo.svg",
				tags: [
					"Web Development",
					"Machine Learning",
					"Databases",
					"Graph databases",
					"DevOps",
					"Dynamics 365",
					"Business solutions",
				],
				description: {
					hr: [],
					en: [
						"<p>At Factory X, we specialize in creating custom software solutions for industries such as education, finance, medicine, recruiting, and beyond. Our focus is on building long-term partnerships and delivering tailored solutions that drive success.</p>",
						"<p>From consultation and requirements gathering to design, development, and support, we take care of it all. Our innovative, secure, and scalable solutions are crafted to overcome your challenges and help your business thrive in an ever-evolving market.</p>",
					],
				},
				extraStyle: {
					maxWidth: "85%"
				}
			},
		],
		l4: [
			{
				name: "EBCONT",
				url: "https://www.ebcont.com/en",
				logo: "ebcont-base-inverted.png",
				tags: [
					"Analisys & Consulting", "AI, Big Data & Search", "UX/UI Design", "Development", "Infrastructure & Operations", "Quality Assurance", "Publishing"
				],
				description: {
					hr: "",
					en: "EBCONT is a leading Austrian IT services company with more than 700 employees that offers IT solutions for more than 130 customers from across all industries including the public sector. Covering the whole IT lifecycle, EBCONT also has an experienced team of AI and Data Science specialists, who employ state-of-the-art approaches and technologies in our customer projects."
				}
			},
			{
				name: "Intersoft",
				logo: "intersoft-inverted-single.svg",
				url: "https://www.intersoft.hr/",
				// linkedIn: "",
				tags: [
					"ERP system",
					"Java",
					"Web development",
					"Oracle",
					"Sencha ExtJS",
					".NET MAUI",
					"tomcat"
				],
				description: {
					hr: [],
					en: [
						"<p>InterSoft d.o.o. is a micro IT manufacturing company, fostering good relations among its employees. We create individual software exclusively for foreign markets in the European Union, while keeping in pace with the latest tools and technologies. We are proud partner of TÜV Austria Group.</p>",
						"<p>Technologies we used to know but are slowly forgetting include VBasic 6 forms, Crystal reports, Openoffice XML, SVN, PHP, and also some quite old terms like Fortran, Delphi and Cobol. We build applications using : C# (Xamarin, MAUI, Syncfusion DOCX and PDF manipulation), JAVA (running in tomcat, with JOOQ data access to ORACLE database, REST-APIs) and javascript (Appex charts, ExtJS framework).</p>"
					],
				},
				extraStyle: {
					maxWidth: "85%"
				}
			},
			{
				name: "Inpro",
				logo: "inpro-hivergen.svg",
				url: "https://inpro.hr/",
				linkedIn: "https://www.linkedin.com/company/inpro-d.o.o.",
				tags: [
					"Hivergen", "Document Management", "Business Intelligence", "Process Automation", "Databases",
					"Digital Transformation", "BPM", "DMS", "BI", "Workflow Optimization"
				],
				description: {
					hr: [],
					en: [
						"<p>Inpro d.o.o. is a technology company with over 30 years of market experience, specializing in the implementation of Document Management Systems (DMS), Business Process Management (BPM) and Business Intelligence (BI). We provide clients with sophisticated solutions for efficient document management and business data analysis.</p>",
						"<p>Our services include the customization and implementation of DMS solutions that enable companies and public institutions to effectively archive, search, and share documents—enhancing productivity and transparency in operations. We also offer BI solutions that support data analysis and visualization, helping businesses improve performance and make informed decisions.</p>"
					],
				},
				extraStyle: {
					maxWidth: "75%"
				}
			},
			{
				name: "McKnight Media",
				url: "https://www.mcknightmedia.co/",
				logo: "mm_typography_white.svg",
				linkedIn: "https://www.linkedin.com/company/mcknight-media/",
				tags: ["UX design", "product design", "enterprise UX", "UX research", "usability testing", "B2B UX training", "UI design", "product management", "UX consulting", "agile UX", "user-centered design", "design systems"],
				description: {
					hr: [],
					en: [
						"<p>McKnight Media is a UX and product design agency specializing in professional software. They create user-friendly products by keeping users involved and continuously challenging assumptions using data and UX best practices.</p>",
						"<p>They are strategic, business-minded thinkers who help teams define clear requirements, integrate UX into agile processes, and catch potential problems early. They also build and maintain design systems, enabling clients to standardize and scale their products effectively.</p>",
						"<p>Additionally, McKnight Media provides B2B UX training specifically tailored for non-designer roles such as product owners, developers, and business analysts. Their team holds recognized certifications from the Nielsen Norman Group (NNg) and the User Experience Qualification Center (UXQCC), helping businesses build strong, UX savvy teams.</p>"
					]
				},
				extraStyle: {
					maxWidth: "85%"
				}
			},
			{
				name: "Nybble",
				url: "https://nybble.hr/",
				logo: "nybble-cut.svg",
				linkedIn: "https://www.linkedin.com/company/nybblecroatia",
				tags: ["Web Development", "Microservices", "Java", "Databases", "k8s", "API", "Banking", "Cash managment", "Human Resources", "ATM", "Cash Deposit", "Finance"],
				description: {
					hr: [],
					en: [
						"<p>Nybble is part of the B.T.C. group, specializing in the development of software solutions within the group. We offer cash management solutions to clients, including banks (SoftCash - cash management in vaults, SmartCash - hardware and software platform for 24/7 cash deposit), retail and hotel chains (CashMatch - hardware and software platform for cash deposit).</p>",
						"<p>Our solutions are based on a microservices architecture, focusing on scalability and high availability, while ensuring a high level of data security.</p>"
					]
				}
			},
			{
				name: "makerspace",
				logo: "makerspace-inverted.svg",
				url: "https://makerspace.hr",
				linkedIn: "https://www.linkedin.com/company/makerspace-varazdin",
				tags: ["Innovation", "Prototyping", "Technical Culture", "Product Development", "STEM activities"],
				description: {
					hr: [],
					en: [
						"<p>Makerspace Varaždin is a non-profit organization dedicated to promoting technical culture by providing knowledge, support, space, and tools for product development.",
						"As a unique workshop space, it offers entrepreneurs, educational institutions, and individuals the necessary resources for rapid prototyping and turning ideas into reality.</p>",
					],
				},
			},
			{
				name: "cWebSpace",
				url: "https://cwebspace.hr",
				logo: "cwebspace-wt.svg",
				linkedIn: "https://www.linkedin.com/company/cwebspace",
				tags: ["Software Development", "Web Development", "Mobile Solutions", "Graphic Design", "Cybersecurity", "Risk Management"],
				description: {
					hr: [],
					en: [
						"<p>cWebSpace develops modern and functional web systems, software, and mobile solutions tailored to business needs. Their focus is on creating smart and efficient digital platforms that follow the latest web standards. In addition to development, they provide graphic design, consulting, and maintenance services, ensuring a complete solution for their clients.</p>",
						"<p>Through cSecureSpace, they also offer security services, including risk management, compliance, pentesting, and security training.</p>"
					]
				},
				extraStyle: {
					maxWidth: "90%"
				}
			},
			{
				name: "Humana Nova",
				logo: "humana_nova-logo2.png",
				url: "https://humananova.org/",
				linkedIn: "https://www.linkedin.com/company/humana-nova",
				description: {
					hr: "",
					en: [
						"<p>Social cooperative Humana Nova is a leading regional social enterprise integrating marginalized communities and ecological care.</p>",
						"<p>Encouraging the employment of disabled and other socially excluded persons is achieved through the production and sale of high-quality and innovative textile products made from ecological and recycled fabrics, catering to both domestic and foreign markets.</p>"
					]
				}
			},
			{
				name: "Printex",
				url: "https://printex.hr/",
				logo: "printex-logo-fb.png",
				tags: ["Printing", "Business Gifts", "Custom Merchandise", "Digital Printing", "Offset Printing"],
				description: {
					hr: "",
					en: ["<p>Printex is a professional printing company with over 30 years of experience. From offset and digital to screen printing, they offer high-quality results on almost any material. Their wide range of services also includes business gifts and custom merchandise, made quickly and with care.</p>",
						"<p>As they like to say: “We print on everything except water and air.”</p>"
					]
				},
				extraStyle: {
					maxWidth: "75%"
				}
			},
			{
				name: "Algebra Bernays",
				logo: "algebra-bernays-h-white-text.svg",
				url: "https://www.algebra.hr/",
				linkedIn: "https://www.linkedin.com/school/algebra-university",
				tags: [
					"Education", "Digital skills", "Data science", "MBA", "Certification", "Digital marketing"
				],
				description: {
					hr: [],
					en: [
						"<p>Algebra Bernays University is a leading private Croatian institution for digital technologies and communications</p>",
						"<p>With 27 years of experience, it combines technical and social sciences to prepare students for the challenges of the digital era.</p>",
						"<p>Algebra Bernays University offers undergraduate and graduate programs in data science, AI, software engineering, game development, digital marketing, communication, and cybersecurity. The university also provides adult education, certifications, MBA programs, and international degrees in partnership with Goldsmiths, University of London.</p>",
						"<p>Its mission: empower individuals and organizations through innovation, practical learning, and future-ready skills.</p>"
					],
				},
				extraStyle: {
					maxWidth: "85%"
				}
			},
			{
				name: "S-Consulting",
				logo: "s-consulting-wt.svg",
				// url: "",
				// linkedIn: "",
				email: "info@sconsulting.hr",
				tags: [
					"Accounting",
					"Bookkeeping",
					"Finance",
					"Taxes",
					"Business consulting",
					"Education"
				],
				description: {
					hr: [],
					en: [
						"<p>S Consulting is a company with years of experience in providing accounting services, business consulting, financial planning and entrepreneur education.</p>",
						"<p>Through a professional and individualized approach, we enable entrepreneurs to optimize their business operations, gain a deeper understanding of financial processes and comply with applicable regulations.</p>"
					],
				},
			},
			{
				name: "Evolva",
				logo: "evolva-light.svg",
				url: "https://www.evolva.hr/",
				linkedIn: "https://www.linkedin.com/company/evolva",
				tags: [
					"Custom business software development",
					"Software integrations",
					"Java web applications",
					"Software development outsourcing",
				],
				description: {
					hr: [],
					en: [
						"<p>Evolva is a software company engaged in developing custom made business web applications and advanced Java web technologies for the application development.</p>",
						"<p>Our customers and professional colleagues use Evolva business solutions and our development technology Evolution Framework to save time and money and to simplify and automate their business processes.</p>"
					],
				},
			},
			{
				name: "IPC",
				logo: "ipc-logo.png",
				url: "https://www.ipc.hr/",
				linkedIn: "https://www.linkedin.com/company/medimurje-ipc",
				tags: [],
				description: {
					hr: [],
					en: [],
				},
				extraStyle: {
					maxWidth: "65%"
				}
			},
		],
		l3: [
			{
				name: "Thera",
				// logo: "thera-logo-v4b-full-white-horizontal.svg",
				logo: "thera-logo-v4b-white-with-accent-horizontal.svg",
				// logoLight: "thera.png"
				url: "https://thera.hr",
				linkedIn: "https://www.linkedin.com/company/thera-webdev",
				tags: ["Web Development", "Frontend & Backend", "Project Management & Consulting"],
				description: {
					hr: [],
					en: [
						"<p>Our mission is to create optimal web based solutions for complex problems, while being fully aligned with your needs and requirements. We can do that as a direct solution provider or as part of a larger team where we will contribute to the development by bringing experience and knowledge to the table, enhancing the whole process.</p>",
						"<p>By openly communicating about all the details - from our first contact, through discovery, development and maintenance stages - we ensure the quality of the product we deliver.</p>",
					],
				},
				extraStyle: {
					maxWidth: "80%"
				}
			},
			{
				name: "ENTRIO",
				logo: "Entrio logo_negative_color.png",
				url: "https://entrio.hr",
				linkedIn: "https://www.linkedin.com/company/entrio/",
				tags: ["Event Ticketing", "Event Management", "Conferences", "Festivals", "User-friendly platform"],
				description: {
					hr: [],
					en: [
						"<p>Entrio is an event ticketing platform, simplifying the ticketing experience for events of all sizes - from conferences and festivals to exclusive workshops.</p>",
						"<p>With intuitive tools for ticket management, audience engagement, and data insights, Entrio helps organizers create memorable events without the hassle.</p>",
					],
				},
			},
			{
				name: "Općina Štrigova",
				logo: "opcina-strigova-grb.png",
				url: "https://opcinastrigova.hr/",
				linkedIn: "",
				description: {
					hr: [],
					en: [
						"<p>Nestled in the beautiful hills of Međimurje, Štrigova is a place where rich history meets a warm, welcoming community. Known for its stunning landscapes, abundant vineyards, and cultural heritage, Štrigova is a picturesque destination where tradition meets innovation.</p>",
						"<p>The Cultural Center Štrigova will serve as the main venue for Weblica 2025, providing a scenic and relaxed setting for learning, networking, and innovation.</p>",
					],
				},
				extraStyle: {
					maxWidth: "45%"
				}
			},
			{
				name: "Streaming.HR",
				logo: "streaming-hr-fixed-white.svg",
				url: "https://www.linkedin.com/company/streaming.hr/",
				linkedIn: "https://www.linkedin.com/company/streaming.hr",
				description: {
					hr: [],
					en: [],
				},
				extraStyle: {
					// maxWidth: "60%"
				}
			},

			{
				name: "The Geek Gathering",
				logo: "tgg-green.svg",
				url: "https://thegeekgathering.org/",
				linkedIn: "https://www.linkedin.com/company/geekgathering/",
				tags: [
					"Conference",
					"Tech",
					"Discussions",
					"Workshops",
					"Osijek",
					"Real talks",
					"Back-to-back insights",
					"Gathering",
				],
				description: {
					hr: [],
					en: [
						"<p>The Geek Gathering is an event brought to you by fellow tech minds. It is designed by and for tech and design experts in Southeastern Europe, the world, the galaxy, the universe, and the metaverse.</p>",
						"<p>TGG is not just a conference but a two-day gathering of tech optimists to exchange ideas, share skills, and build connections.</p>",
						"<p>Our goal is to bring together tech talent, entrepreneurs, and thought leaders to establish a hub of tech innovation and disruption in Osijek and the surrounding region.</p>",
						"<p>In 2024, a partnership between The Geek Gathering and Weblica was formed, recognizing that similar events with a shared mission of advancing tech knowledge should support one another.</p>",
					],
				},
			},
			{
				name: "Web Summer Camp",
				logo: "wsc-25-logo-horizontal-wt.svg",
				url: "https://websummercamp.com/2025",
				linkedIn: "https://www.linkedin.com/company/web-summer-camp",
				tags: [
					"Web Development", "UX", "Python", "AI", "Javascript", "PHP", "Business solutions"
				],
				description: {
					hr: [],
					en: [
						"Web Summer Camp is a three-day international conference where web professionals gather to learn, share, and grow. With practical workshops and thought-provoking discussions, it’s the perfect blend of hands-on learning and networking. This year’s Web Summer Camp offers six tracks: Digital Change, Founders, UX, Python/AI, JavaScript and PHP."
					],
				},
			},
			{
				name: "Full Circle",
				logo: "full-circle-logo.svg",
				url: "https://www.facebook.com/fullcircle123",
				// linkedIn: "",
				tags: [
					"Food", "Sustainability", "Local Sourcing", "Circular Economy", "Street Food"
				],
				description: {
					hr: "",
					en: [
						"<p>Full Circle is a food project created by Marko Palfi in collaboration with The Garden Brewery. Focused on high-quality fried chicken marinated with yogurt and Pale Ale, Full Circle sources fresh ingredients from local farmers and markets. Alongside chicken, they offer a full vegetarian range and are the first in Croatia to serve beyond chicken nuggets.</p>",
						"<p>Their concept supports sustainable farming - even spent grain from brewing is reused as feed for chickens, closing the loop from brewery to plate.</p>"
					]
				}
			},
			{
				name: "Storenest",
				logo: "storenest-alt.svg",
				url: "http://storenest.hr/",
				linkedIn: "http://linkedin.com/company/storenest",
				tags: ["E-commerce", "Webshop", "SaaS", "AI Analytics"],
				description: {
					hr: [],
					en: [
						"Storenest is a comprehensive eCommerce platform that enables merchants to quickly and easily launch their own online store—in just a few clicks.",
						"No technical knowledge is required, as users get a complete solution with pre-integrated systems for payments, shipping, accounting, and analytics.",
						"Advanced AI technology automates key processes, improves sales performance, and enhances customer engagement.",
						"In addition to technical support, Storenest also provides legal consulting, ensuring that webshops comply with all relevant regulations. Our mission is to empower merchants to focus on growing their business while we take care of the technology."
					],
				},
				extraStyle: {
					maxWidth: "80%"
				}
			},
			{
				name: "CYCLE",
				logo: "cycle-logo-white.svg",
				url: "https://cycle.io/",
				linkedIn: "",
				tags: [],
				description: {
					hr: [],
					en: [
						"Cycle is the leading LowOps platform built to simplify both container orchestration and infrastructure management. Deploy to your own infrastructure, whether that's on-premise or across multiple clouds."
					],
				},
				extraStyle: {
					// maxWidth: "80%"
				}
			},
		],
		l2: [
			{
				name: "Netokracija",
				logo: "netokracija_for_black background.png",
				url: "https://www.netokracija.com/",
				linkedIn: "https://www.linkedin.com/company/netokracija",
				tags: ["Digital media", "IT news", "Tech Journalism", "Marketing", "Entrepreneurship"],
				description: {
					hr: [],
					en: [
						"<p>Netokracija is the leading digital media in the region, covering tech, startups, and digital business.",
						"They stand out with in-depth analysis, exclusive insights, and a deep understanding of the local and global tech scene.</p>",
					],
				},
				// extraStyle: {
				// 	maxWidth: "130%"
				// }
			},
			{
				name: "Murska Dekla",
				logo: "murska-dekla-inverted.svg",
				url: "https://www.murskadekla.com/",
				linkedIn: "",
				facebook: "https://www.facebook.com/murskadekla",
				instagram: "https://www.instagram.com/murskadekla/",
				tags: [],
				description: {
					hr: [],
					en: [
						"<p>Blazar Distillery is a craft distillery dedicated to creating high-quality, small-batch spirits, with its flagship Murska Dekla London dry gin inspired by the natural richness of northern Croatia.</p>",
						"<p>Murska Dekla, named after a mythical guardian of nature and water, reflects this connection through a carefully guarded recipe infused with a variety of wild herbs.</p>",
						"<p>Using time-honored distillation methods, crystal-clear local water, and traditional copper pot stills, each batch is crafted with precision and care. Aged in oak barrels and enhanced with a select blend of botanicals, Murska Dekla gin delivers a refined, aromatic profile and a smooth, full-bodied taste.</p>",
						"<p>From ingredient selection to bottling, Blazar Distillery is committed to producing spirits that honor nature, tradition, and quality.</p>"
					],
				},
				extraStyle: {
					// maxWidth: "70%"
				}
			},
			{
				name: "JAKOPIĆ",
				logo: "jakopic-white.svg",
				url: "https://jakopic-travel.hr/",
				linkedIn: "",
				tags: [],
				description: {
					hr: [],
					en: [],
				},
				extraStyle: {
					// maxWidth: "70%"
				}
			},
			{
				name: "PRO LED",
				logo: "proled.png",
				facebook: "https://facebook.com/Proledrentals/",
				linkedIn: "",
				tags: [],
				description: {
					hr: [],
					en: [],
				},
				extraStyle: {
					maxWidth: "70%"
				}
			},
			{
				name: "Računalniške novice",
				logo: "racunalniske-novice-white.png",
				url: "https://racunalniske-novice.com/",
				linkedIn: "https://www.linkedin.com/company/racunalniskenovice",
				tags: ["IT News", "Digital Business", "Technology Journalism", "Technology News", "Slovenia Tech Media"],
				description: {
					hr: [],
					en: [
						"<p>Računalniške novice is one of the most important and widely read technology media in Slovenia, with a long tradition of covering innovations in information technology.</p>",
						"<p>Their online portal and print edition provide expert analysis, reviews, news, and guides on computers, mobile devices, software, artificial intelligence, cybersecurity, and digital business.</p>",
						"<p>Besides current tech topics, Računalniške novice also offers advice for professionals and enthusiasts, helping them stay ahead in the fast-changing digital world. Thanks to reliable and relevant content, they have built a strong reader base, including IT experts, entrepreneurs, and tech enthusiasts in Slovenia and beyond.</p>",
					],
				},
				extraStyle: {
					maxWidth: "70%"
				}
			},
		],
		l1: [

		],
	},
	exhibitors: [],
	partners: {},
	mediaPartners: [],
	survey: {
		_FULL_TEMPLATE: [
			{
				required: true,
				event: [ // specific for given event(s) - if not defined (or empty) it will be shown on all events
					"weblica"
				],
				question: { // also used to generate "key" needed for internal logic
					hr: "Koliko ste općenito zadovoljni događajem?",
					en: "How satisfied were you with the event in general?",
				},
				description: { // additional info about the question, eq. clarification
					hr: "Općenito organizacija i dojam koji je događaj ostavio na Vas.",
					en: "General organization and the impression the event left on you."
				},
				stars: true, // show stars
				boolean: true, // show yes/no
				comment: true, // show comment box
				comment_opt: true, // show optional comment box
				options: { // show selection list
					type: "checkbox", // checkbox | radio
					items: [
						{
							value: "collegues",
							hr: "Kolega u firmi",
							en: "Colleagues in the company",
						},
						{
							value: "online",
							hr: "Negdje na internetu",
							en: "Somewhere online",
						},
					]
				},
			}
		],
		options: {
			combinedEvents: ["weblica", "worklica"] // if defined, survey will show combined title + combined sessions (separated into section with event name)
		},
		// generic survey questions (used only if event specific are not defined)
		__visitors: [ // DEBUG ONLY
			[
				{
					// OK
					required: true,
					question: {
						hr: "Ovo je test!",
						en: "this is a test!",
					},
					options: {
						type: "radio",
						items: [
							{
								value: "val1",
								text: {
									hr: "",
									en: "Value 1",
								},
							},
							{
								value: "val2",
								text: {
									hr: "",
									en: "Value 2",
								},
							},
							{
								value: "val3",
								text: {
									hr: "",
									en: "Value 3",
								},
							}
						],
					},
					comment_opt: true
				},
				{
					// OK
					required: true,
					question: {
						hr: "Koliko ste općenito zadovoljni događajem?",
						en: "How satisfied were you with the event in general?",
					},
					stars: true,
					comment_opt: true
				},
			],
			[
				{
					// OK
					question: {
						hr: "Kako ste saznali za ovaj događaj?",
						en: "How did you hear about this event?",
					},
					options: {
						type: "checkbox",
						items: [
							{
								value: "colleague-friend",
								text: {
									hr: "Kolega/Prijatelj/Poznanik",
									en: "Colleague/Friend/Acquaintance",
								},
							},
							{
								value: "social-network",
								text: {
									hr: "Društvene mreže",
									en: "Social network",
								},
							},
							{
								value: "portal",
								text: {
									hr: "IT portal",
									en: "IT portal",
								},
							},
							{
								value: "newsletter",
								text: {
									hr: "Newsletter",
									en: "Newsletter",
								},
							},
							{
								value: "poster",
								text: {
									hr: "Plakat",
									en: "Poster",
								},
							},
							{
								value: "other",
								text: {
									hr: "Neki drugi način ...",
									en: "Some other way ...",
								},
							},
						],
					},
					comment_opt: true,
					comment_placeholder: {
						hr: "Ako ste saznali na neki drugi način, molimo da ovdje napišete kako?",
						en: "If you heard about this event in another way, please tell us how?",
					},
				},
				{
					// OK
					required: true,
					question: {
						hr: "Jeste li već bili na ovom događaju?",
						en: "Have you attended this event before?",
					},
					boolean: true,
					comment_opt: true,
				},
			],
			{
				// OK
				question: {
					hr: "Molimo podijelite sve dodatne komentare, misli, prijedloge za buduće događaje.",
					en: "Please share any additional comments, thoughts, suggestions for future events.",
				},
				comment: true,
			},
		],
		visitors: [
			{
				// OK
				required: true,
				question: {
					hr: "Koliko ste općenito zadovoljni događajem?",
					en: "How satisfied were you with the event in general?",
				},
				stars: true,
				comment_opt: true
			},
			{
				// OK
				required: true,
				question: {
					hr: "Koliko ste zadovoljni ukupnom kvalitetom predavanja?",
					en: "How satisfied are you with the general quality of the sessions?",
				},
				stars: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Koje je bilo Vaše najdraže iskustvo ili trenutak događaja?",
					en: "What was your favorite experience or moment of the event?",
				},
				comment: true,
			},
			{
				// OK
				question: {
					hr: "Što bismo mogli poboljšati?",
					en: "What could we improve on?",
				},
				comment: true,
			},
			{
				// OK
				question: {
					hr: "Da li je događaj ispunio vaša očekivanja?",
					en: "Did the event meet your expectations?",
				},
				boolean: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Kolika je vjerojatnost da ćete u budućnosti posjećivati ​​naše događaje?",
					en: "How likely would you be to attend our events in the future?",
				},
				stars: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Biste li naše događaje preporučili prijatelju ili kolegi?",
					en: "Would you recommend our events to a friend or colleague?",
				},
				boolean: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Jeste li imali priliku i mjesto za postavljanje pitanja i sudjelovanje?",
					en: "Did you have an opportunity and place to ask questions and participate?",
				},
				boolean: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Koliko ste bili zadovoljni pruženim mogućnostima umrežavanja?",
					en: "How satisfied were you with the networking opportunities provided?",
				},
				stars: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Kako ste saznali za ovaj događaj?",
					en: "How did you hear about this event?",
				},
				options: {
					type: "checkbox",
					items: [
						{
							value: "colleague-friend",
							text: {
								hr: "Kolega/Prijatelj/Poznanik",
								en: "Colleague/Friend/Acquaintance",
							},
						},
						{
							value: "social-network",
							text: {
								hr: "Društvene mreže",
								en: "Social network",
							},
						},
						{
							value: "portal",
							text: {
								hr: "IT portal",
								en: "IT portal",
							},
						},
						{
							value: "newsletter",
							text: {
								hr: "Newsletter",
								en: "Newsletter",
							},
						},
						{
							value: "poster",
							text: {
								hr: "Plakat",
								en: "Poster",
							},
						},
						{
							value: "other",
							text: {
								hr: "Neki drugi način ...",
								en: "Some other way ...",
							},
						},
					],
				},
				comment_opt: true,
				comment_placeholder: {
					hr: "Ako ste saznali na neki drugi način, molimo da ovdje napišete kako?",
					en: "If you heard about this event in another way, please tell us how?",
				},
			},
			{
				// OK
				question: {
					hr: "Jeste li već bili na ovom događaju?",
					en: "Have you attended this event before?",
				},
				boolean: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Koliko Vam je osoblje bilo od pomoći?",
					en: "How helpful was the staff at the event?",
				},
				stars: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Koliko je platforma za događaj bila jednostavna za navigaciju?",
					en: "How easy-to-navigate was the platform for the event?",
				},
				stars: true,
				comment_opt: true,
			},
			{
				// OK - ADDED
				question: {
					hr: "Da li su oznake u i oko prostora bile dostatne za snalaženje?",
					en: "Were the markings in and around the event area sufficient for navigation?",
				},
				stars: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Koje biste teme voljeli vidjeti više na budućim događanjima?",
					en: "What topics would you want to see more of at future events?",
				},
				comment: true,
			},
			{
				// OK
				question: {
					hr: "Molimo podijelite sve dodatne komentare, misli, prijedloge za buduće događaje.",
					en: "Please share any additional comments, thoughts, suggestions for future events.",
				},
				comment: true,
			},
		],
		speakers: [
			{
				// OK
				required: true,
				question: {
					hr: "Koliko ste općenito zadovoljni događajem?",
					en: "How satisfied were you with the event in general?",
				},
				stars: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Koje je bilo Vaše najdraže iskustvo ili trenutak događaja?",
					en: "What was your favorite experience or moment of the event?",
				},
				comment: true,
			},
			{
				// OK
				question: {
					hr: "Gdje ste saznali da se možete prijaviti kao predavač na našoj konferenciji?",
					en: "Where did you find out that you can register as a lecturer at our conference?",
				},
				comment: true,
			},
			{
				// OK
				question: {
					hr: "Jesu li tehnička podrška i oprema zadovoljili vaše potrebe tijekom predavanja?",
					en: "Did the technical support and equipment meet your needs during the presentation?",
				},
				boolean: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Kako ocjenjujete organizaciju i komunikaciju s organizacijskim timom prije i tijekom konferencije?",
					en: "How do you rate the organization and communication with the organizing team before and during the conference?",
				},
				stars: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Kako biste ocijenili interes i angažman publike tijekom vašeg predavanja?",
					en: "How would you assess the interest and engagement of the audience during your presentation?",
				},
				stars: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Jesu li vam pružene dovoljne prilike za networking i interakciju s ostalim predavačima i sudionicima?",
					en: "Were you provided with sufficient opportunities for networking and interaction with other speakers and participants?",
				},
				boolean: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Postoji li nešto što bi moglo biti poboljšano u vezi s vašim iskustvom na konferenciji?",
					en: "Is there anything that could be improved in relation to your experience at the conference?",
				},
				comment: true,
			},
			{
				// OK
				// required: true,
				question: {
					hr: "Biste li se željeli vratiti kao predavač na budućim izdanjima naše konferencije?",
					en: "Would you like to return as a speaker at future editions of our conference?",
				},
				boolean: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Imate li preporuke za teme ili sadržaje koji bi mogli obogatiti buduća izdanja naše konferencije?",
					en: "Do you have any recommendations for topics or content that could enrich future editions of our conference?",
				},
				comment: true,
			},
		],
	},
}
